/**
 * हिन्दी — everyday, respectful register (aap-form), MyGate-style vocabulary
 * (common transliterations like गेट/पास/डिलीवरी stay — that's how people speak).
 * DRAFTED BY LLM — needs native-speaker review before public launch (I18N_PLAN).
 */
import type { Dict } from './en';

export const hi: Dict = {
  cancel: 'रद्द करें',
  retry: 'फिर से कोशिश करें',
  back_to_home: 'होम पर वापस जाएँ',

  tab_home: 'होम',
  tab_community: 'कम्युनिटी',
  tab_gate: 'गेट',
  tab_pay: 'पेमेंट',

  greeting_morning: 'सुप्रभात',
  greeting_afternoon: 'नमस्ते',
  greeting_evening: 'शुभ संध्या',
  urgent_notice: 'ज़रूरी सूचना',
  acknowledge: 'पढ़ लिया',
  visitor_at_gate: 'गेट पर विज़िटर',
  delivery_waiting: 'एक डिलीवरी आपकी मंज़ूरी का इंतज़ार कर रही है। देखने के लिए टैप करें।',
  quick_actions: 'झटपट काम',
  qa_visitor: 'विज़िटर',
  qa_helpdesk: 'हेल्पडेस्क',
  qa_pay: 'पेमेंट',
  qa_book: 'बुकिंग',
  qa_preapprove: 'प्री-अप्रूव',
  qa_book_amenity: 'हॉल बुक करें',
  recent_activity: 'हाल की गतिविधि',
  nothing_new: 'अभी कुछ नया नहीं है।',
  couldnt_load_notices: 'सूचनाएँ अभी लोड नहीं हो पाईं।',
  all_services: 'सभी सेवाएँ',
  grp_gate_visitors: 'गेट और विज़िटर',
  grp_staff_home: 'घर का स्टाफ़',
  grp_bookings: 'बुकिंग',
  grp_society: 'सोसाइटी',
  svc_gate_pass: 'गेट पास',
  svc_parcels: 'पार्सल',
  svc_vehicles: 'गाड़ियाँ',
  svc_family: 'परिवार',
  svc_kids: 'बच्चे',
  svc_move: 'शिफ़्टिंग',
  svc_my_staff: 'मेरा स्टाफ़',
  svc_attendance: 'हाज़िरी',
  svc_venues: 'हॉल बुकिंग',
  svc_my_bookings: 'मेरी बुकिंग',
  svc_finances: 'हिसाब-किताब',
  svc_documents: 'दस्तावेज़',
  svc_directory: 'डायरेक्टरी',
  svc_sos: 'SOS',
  push_primer_title: 'गेट पर कोई आए तो तुरंत जानें',
  push_primer_body: 'विज़िटर, ज़रूरी सूचनाएँ, गेस्ट पास — सब कुछ तुरंत।',
  push_primer_cta: 'अलर्ट चालू करें',
  push_primer_later: 'बाद में',

  main_gate_now: 'मुख्य गेट · अभी',
  close_wo_deciding: 'बिना फ़ैसला किए बंद करें',
  for_flat: '{purpose} · फ़्लैट {flat} के लिए',
  photo_taken: 'गेट पर फोटो ली गई',
  logged_by: 'दर्ज किया',
  gate_desk: 'गेट डेस्क',
  arrived_at: 'आने का समय',
  id_checked: 'ID देखी गई',
  auto_deny_in: 'अपने आप मना होगा',
  allow_in: 'अंदर आने दें',
  allowed_notified: 'अनुमति दी — गार्ड को बता दिया',
  leave_at_gate: 'गेट पर छोड़ें',
  kept_at_gate: 'गेट पर रखा गया',
  deny: 'मना करें',
  denied: 'मना किया',
  decide_error: 'आपका फ़ैसला भेजा नहीं जा सका। इंटरनेट देखकर फिर से कोशिश करें।',
  no_one_waiting: 'गेट पर कोई इंतज़ार नहीं कर रहा',
  no_one_waiting_body: 'जब कोई आपके फ़्लैट के लिए आएगा, उसकी मंज़ूरी यहाँ दिखेगी।',
  couldnt_load_visitors: 'विज़िटर लिस्ट नहीं खुल पाई',
  couldnt_load_visitors_body: 'अभी विज़िटर लिस्ट नहीं मिल रही। थोड़ी देर में फिर कोशिश करें।',

  emergency: 'इमरजेंसी',
  sos_alert: 'SOS अलर्ट',
  sos_hold_instruction: 'सुरक्षा और कमेटी को इमरजेंसी अलर्ट भेजने के लिए नीचे का बटन दबाकर रखें।',
  hold: 'दबाए रखें',
  call_112: '112 पर कॉल करें',
  sos_when_send: 'SOS भेजने पर:',
  sos_send_guards: 'सभी गार्ड को तुरंत अलर्ट जाएगा',
  sos_send_committee: 'कमेटी को सूचना जाएगी',
  sos_send_contact: 'आपके इमरजेंसी नंबर पर कॉल जाएगा',
  sos_send_flatinfo: 'आपके फ़्लैट की जानकारी मदद करने वालों को दी जाएगी',
  quick_dial: 'तुरंत कॉल',
  sos_sent: 'SOS भेज दिया',
  sos_on_way: 'सुरक्षा टीम आ रही है।',
  cancel_sos: 'SOS रद्द करें',
  sos_error: 'SOS नहीं भेजा जा सका। फिर से कोशिश करें या सीधे गेट पर कॉल करें।',
  sos_type_medical: 'मेडिकल',
  sos_type_fire: 'आग',
  sos_type_security: 'सुरक्षा',
  sos_type_other: 'अन्य',

  login_tagline: 'आपकी सोसाइटी का हर गेट, एक शांत ऐप।',
  sign_in: 'साइन इन करें',
  login_sub: 'वही ईमेल डालें जो सोसाइटी में दर्ज है।',
  email: 'ईमेल',
  password: 'पासवर्ड',
  enter_password: 'पासवर्ड डालें',
  show: 'दिखाएँ',
  hide: 'छिपाएँ',
  forgot_password: 'पासवर्ड भूल गए?',
  or: 'या',
  new_to_bero: 'Bero पर नए हैं?',
  create_account: 'खाता बनाएँ',

  main_gate: 'मुख्य गेट',
  on_duty: 'ड्यूटी पर',
  sign_out: 'साइन आउट',
  stat_inside: 'अंदर',
  stat_awaiting: 'इंतज़ार में',
  stat_today: 'आज',
  new_entry: 'नई एंट्री',
  kiosk_visitor: 'विज़िटर',
  kiosk_visitor_sub: 'सीधे आया व्यक्ति',
  kiosk_delivery: 'डिलीवरी',
  kiosk_delivery_sub: 'गेट पर कूरियर',
  kiosk_cab: 'कैब / ड्राइवर',
  kiosk_cab_sub: 'लेने या छोड़ने आया',
  gate_desk_hdr: 'गेट डेस्क',
  validate_pass: 'पास जाँचें',
  validate_pass_sub: 'गेस्ट का PIN',
  staff_punch: 'स्टाफ़ हाज़िरी',
  staff_punch_sub: 'गेट कोड इन/आउट',
  todays_log: 'आज का रिकॉर्ड',
  todays_log_sub: 'सभी एंट्री',
  incident: 'घटना',
  incident_sub: 'ऑफ़िस को बताएँ',
  messages: 'संदेश',
  kid_exits: 'बच्चों का बाहर जाना',
  no_entries_today: 'आज अभी कोई एंट्री नहीं।',
  mark_entered: 'अंदर आया',
  mark_left: 'बाहर गया',

  who_at_gate: 'गेट पर कौन है?',
  type_visitor: 'विज़िटर',
  type_delivery: 'डिलीवरी',
  type_cab: 'कैब',
  company: 'कंपनी',
  cab_service: 'कैब सर्विस',
  person_name_opt: 'नाम (ज़रूरी नहीं)',
  name_lbl: 'नाम',
  full_name: 'पूरा नाम',
  flat_lbl: 'फ़्लैट',
  type_or_pick: 'टाइप करें या नीचे से चुनें',
  wing_chip: 'विंग {code}',
  phone_opt: 'फ़ोन (ज़रूरी नहीं)',
  vehicle_number: 'गाड़ी नंबर',
  visitor_photo: 'विज़िटर की फोटो',
  take_photo: 'फोटो लें',
  add_photo: 'फोटो जोड़ें',
  retake_photo: 'फोटो दोबारा लें',
  companions: 'साथ में लोग (+N)',
  leave_at_gate_lbl: 'गेट पर छोड़ें',
  leave_at_gate_sub: 'रेज़िडेंट से पूछे बिना पार्सल दर्ज करें।',
  ask_resident: 'रेज़िडेंट से मंज़ूरी माँगें',
  log_parcel: 'पार्सल गेट पर दर्ज करें',
  err_flat_not_found: 'फ़्लैट नहीं मिला — फ़्लैट कोड जाँचें।',
  err_fill_name: 'नाम (या कंपनी) और फ़्लैट कोड भरें।',
  err_entry_generic: 'एंट्री दर्ज नहीं हो पाई। फिर से कोशिश करें।',
  err_camera: 'कैमरा नहीं खुल पाया।',

  alerts_title: 'नोटिफ़िकेशन चालू करें',
  alerts_sub: 'इनके बिना Bero काम नहीं कर सकता। गेट से आप तक बात इन्हीं से पहुँचती है।',
  alerts_r1_title: 'गेट पर विज़िटर',
  alerts_r1_body: 'मेहमान, डिलीवरी और कैब को सेकंडों में मंज़ूरी दें — जवाब आने तक वे गेट पर रुके रहते हैं।',
  alerts_r2_title: 'पार्सल और पास',
  alerts_r2_body: 'पार्सल गेट पर पहुँचे या मेहमान अंदर आए — तुरंत पता चले।',
  alerts_r3_title: 'ज़रूरी सोसाइटी सूचनाएँ',
  alerts_r3_body: 'पानी बंद, बिजली बंद, इमरजेंसी — कमेटी के डालते ही आप तक।',
  alerts_r4_title: 'परिवार का SOS',
  alerts_r4_body: 'घर का कोई SOS दबाए तो आपको तुरंत पता चले।',
  alerts_cta: 'नोटिफ़िकेशन चालू करें',
  alerts_cta_settings: 'सेटिंग्स खोलकर अनुमति दें',
  alerts_settings_hint: 'फ़ोन की सेटिंग्स में Bero के नोटिफ़िकेशन अभी बंद हैं।',
  alerts_skip: 'अभी नहीं',

  // shared across guard screens
  allow_entry: 'अंदर आने दें',
  back_to_gate: 'गेट पर वापस',
  filter_all: 'सभी',
  filter_approved: 'मंज़ूर',
  filter_rejected: 'मना किया',
  filter_awaiting: 'इंतज़ार में',

  // guard — validate pass
  validate_scan_qr: 'QR कोड स्कैन करें',
  validate_aim_qr: 'पास के QR पर कैमरा रखें',
  validate_cam_off: 'कैमरे की अनुमति बंद है — सेटिंग्स में चालू करें, या नीचे PIN डालें।',
  validate_pin_label_or: 'या गेस्ट का 6 अंकों का PIN डालें',
  validate_pin_label: 'गेस्ट का 6 अंकों का PIN',
  validate_pin_help: 'उनके पास पर, QR के नीचे।',
  validate_check: 'पास जाँचें',
  validate_not_found: 'इस कोड का कोई पास नहीं मिला।',
  validate_check_error: 'कोड जाँचा नहीं जा सका। फिर से कोशिश करें।',
  validate_entered_logged: 'अंदर आया — दर्ज हो गया',
  validate_daily_window: 'रोज़ का समय: {window}',

  // guard — waiting for resident
  waiting_title: 'रेज़िडेंट का इंतज़ार',
  waiting_buzzing: 'रेज़िडेंट का फ़ोन बज रहा है…',
  waiting_sent_ago: '{n} सेकंड पहले भेजा',
  waiting_approved: 'रेज़िडेंट ने मंज़ूरी दी',
  waiting_rejected: 'मना किया — अंदर न आने दें',
  waiting_left_at_gate: 'गेट पर छोड़ा — रेज़िडेंट ने अंदर आने से मना किया।',

  // guard — gate log
  log_title: 'गेट रिकॉर्ड',
  log_empty_title: 'यहाँ कुछ नहीं',
  log_empty_body: 'इस फ़िल्टर से मिलती एंट्री यहाँ दिखेंगी।',
  log_report_link: 'गलती बताएँ',
  log_report_hdr: 'गलत एंट्री की शिकायत करें',
  log_report_explain: 'एंट्री रिकॉर्ड में रहती है — उस पर निशान लग जाता है और सोसाइटी ऑफ़िस को बता दिया जाता है। एंट्री कभी बदली या हटाई नहीं जाती।',
  log_report_field: 'क्या गलत हुआ?',
  log_report_placeholder: 'जैसे गलत फ़्लैट डाला — विज़िटर B-विंग के लिए था',
  log_report_need_reason: 'पहले बताएँ क्या गलत हुआ।',
  log_reported_ok: 'शिकायत भेज दी — ऑफ़िस को बता दिया गया।',
  log_report_error: 'इस एंट्री की शिकायत नहीं भेजी जा सकी।',
  log_reporting: 'भेज रहे हैं…',
  log_report_submit: 'एंट्री की शिकायत करें',

  // guard — messages from flats
  msgs_title: 'फ़्लैट से संदेश',
  msgs_empty_title: 'कोई संदेश नहीं',
  msgs_empty_body: 'रेज़िडेंट गेट पर जो नोट भेजेंगे वे यहाँ दिखेंगे।',

  // guard — kid exits
  kids_title: 'बच्चों का बाहर जाना',
  kids_intro: 'माता-पिता ने इन बच्चों को बाहर जाने दिया है। बच्चा निकले तब पुष्टि करें — फ़्लैट को सूचना चली जाएगी।',
  kids_empty_title: 'कोई चालू अनुमति नहीं',
  kids_empty_body: 'माता-पिता की एक-बार की अनुमतियाँ यहाँ दिखेंगी।',
  kids_until: '{time} तक',
  kids_confirming: 'पुष्टि हो रही है…',
  kids_confirm: 'बाहर जाने की पुष्टि',

  // guard — staff punch
  punch_code_label: 'स्टाफ़ गेट कोड',
  punch_code_help: 'उनका अपना 4 अंकों का कोड।',
  punch_action: 'पंच करें',
  punch_not_found: 'इस कोड का कोई स्टाफ़ नहीं मिला।',
  punch_error: 'पंच नहीं हो सका। फिर से कोशिश करें।',
  punch_checked_in: 'अंदर आया',
  punch_checked_out: 'बाहर गया',

  // guard — incidents
  incidents_title: 'घटनाएँ',
  incidents_log: 'घटना दर्ज करें',
  incidents_sheet_sub: 'आपके दर्ज करते ही एडमिन और कमेटी को सूचना चली जाती है।',
  incidents_field: 'क्या हुआ?',
  incidents_placeholder: 'जैसे गेट 2 पर एक अनजान दोपहिया एक घंटे से खड़ा है',
  incidents_need_note: 'पहले घटना बताएँ।',
  incidents_logged_ok: 'दर्ज हो गया — एडमिन और कमेटी को अलर्ट भेज दिया गया।',
  incidents_log_error: 'घटना दर्ज नहीं हो सकी।',
  incidents_resolved_ok: 'निपटा हुआ चिह्नित किया।',
  incidents_resolve_error: 'निपटाया नहीं जा सका।',
  incidents_empty_title: 'कोई घटना नहीं',
  incidents_empty_body: 'गेट पर कुछ भी असामान्य — यहाँ दर्ज करें और ऑफ़िस को तुरंत पता चल जाएगा।',
  incidents_logged_by: '{name} ने दर्ज किया',
  incidents_mark_resolved: 'निपटा हुआ चिह्नित करें',
  incidents_logging: 'दर्ज हो रहा है…',
  incidents_log_submit: 'घटना दर्ज करें',
  inc_kind_security: 'सुरक्षा',
  inc_kind_fire: 'आग',
  inc_kind_medical: 'मेडिकल',
  inc_kind_maintenance: 'मेंटेनेंस',
  inc_kind_other: 'अन्य',

  // common (added tranche 3)
  close: 'बंद करें',

  // parcels
  parcels_title: 'गेट पर पार्सल',
  parcels_pin_title: 'आपका डिलीवरी PIN',
  parcels_pin_sub: 'डिलीवरी वाले गेट पर यह बताकर बिना कॉल किए पार्सल छोड़ सकते हैं।',
  parcels_pick_error: 'पार्सल उठाया हुआ चिह्नित नहीं हो सका। फिर से कोशिश करें।',
  parcels_empty_title: 'गेट पर कोई पार्सल नहीं',
  parcels_empty_body: 'जब कोई कूरियर गार्ड के पास पैकेट छोड़ेगा, वह यहाँ दिखेगा।',
  parcels_empty_err_title: 'पार्सल उपलब्ध नहीं',
  parcels_empty_err_body: 'अभी गेट डेस्क से संपर्क नहीं हो पा रहा।',
  parcels_at_desk: 'गार्ड डेस्क पर',
  parcels_collected: 'ले लिए गए',
  parcels_mark_picked: 'उठाया चिह्नित करें',

  // gate pass — list + single pass UI (ticket face stays English)
  gp_list_title: 'गेट पास',
  gp_new: '+ नया',
  gp_empty_title: 'अभी कोई गेट पास नहीं',
  gp_empty_body: 'विज़िटर को प्री-अप्रूव करें और QR + PIN वाला शेयर करने योग्य पास बनाएँ।',
  gp_empty_err_title: 'पास लोड नहीं हो सके',
  gp_empty_err_body: 'थोड़ी देर में फिर कोशिश करें।',
  gp_preapprove_cta: 'विज़िटर को प्री-अप्रूव करें',
  gp_title: 'गेट पास',
  gp_share: 'शेयर करें',
  gp_share_to_guest: 'गेस्ट को भेजें',
  gp_copied: 'कॉपी हो गया',
  gp_copy_code: 'कोड कॉपी करें',
  gp_copy_error: 'कोड कॉपी नहीं हो सका। इसे खुद सेलेक्ट करके कॉपी करें।',
  gp_share_dialog: '{name} के लिए गेट पास',
  gp_info_note: 'गार्ड इसे अपने आप जाँच लेते हैं। आपके गेस्ट को कोई ऐप नहीं चाहिए।',
  gp_cancel_pass: 'पास रद्द करें',
  gp_revoke_error: 'यह पास अभी रद्द नहीं हो सका। थोड़ी देर में फिर कोशिश करें।',
  gp_cancelled_title: 'पास रद्द हो गया',
  gp_cancelled_body: '{name} का पास रद्द कर दिया गया है और अब गेट पर इस्तेमाल नहीं हो सकता।',
  gp_preapprove_another: 'दूसरे विज़िटर को प्री-अप्रूव करें',
  gp_revoke_hdr: 'यह पास रद्द करें?',
  gp_revoke_body: '{name} अब इस कोड या QR को गेट पर इस्तेमाल नहीं कर पाएँगे। यह वापस नहीं होगा।',
  gp_keep_pass: 'पास रहने दें',
  gp_cancelling: 'रद्द हो रहा है…',

  // pre-approve visitor (big form)
  pa_title: 'विज़िटर प्री-अप्रूव करें',
  pa_purpose: 'मकसद',
  pa_purpose_guest: 'गेस्ट',
  pa_purpose_delivery: 'डिलीवरी',
  pa_purpose_cab: 'कैब',
  pa_purpose_help: 'हेल्प',
  pa_how_often: 'कितनी बार',
  pa_freq_once: 'एक बार',
  pa_freq_frequent: 'बार-बार',
  pa_frequent_note: 'एक पास, कई बार एंट्री — ऑफ़िस कैब, रोज़ की डिलीवरी या ज़्यादा दिन रुकने वाले गेस्ट के लिए।',
  pa_delivery_company: 'डिलीवरी कंपनी',
  pa_type_of_help: 'किस तरह की हेल्प',
  pa_help_maid: 'मेड',
  pa_help_cook: 'कुक',
  pa_help_driver: 'ड्राइवर',
  pa_help_electrician: 'इलेक्ट्रीशियन',
  pa_help_plumber: 'प्लंबर',
  pa_help_carpenter: 'कारपेंटर',
  pa_help_other: 'अन्य',
  pa_help_other_ph: 'जैसे AC टेक्नीशियन',
  pa_name_delivery: 'डिलीवरी वाले का नाम (ज़रूरी नहीं)',
  pa_name_helper: 'हेल्पर का नाम',
  pa_name_visitor: 'विज़िटर का नाम',
  pa_name_ph_delivery: 'अगर पता हो कौन आ रहा है',
  pa_name_ph_helper: 'जैसे रमेश यादव',
  pa_name_ph_visitor: 'जैसे संजय शर्मा',
  pa_pick_contacts: 'कॉन्टैक्ट्स से चुनें →',
  pa_phone: 'फ़ोन नंबर',
  pa_phone_help: 'एंट्री कोड इसी नंबर पर मिलेगा।',
  pa_guest_n_name: 'गेस्ट {n} का नाम',
  pa_remove_guest: 'गेस्ट हटाएँ',
  pa_add_guest: '+ एक और गेस्ट जोड़ें — हर किसी को अपना पास मिलेगा',
  pa_multi_title: 'कई बार एंट्री',
  pa_multi_sub: 'गेस्ट एक ही पास से समय के अंदर आ-जा सकते हैं।',
  pa_leave_sub: 'अगर आप जवाब न दें, तो गार्ड पार्सल गेट पर रख लेता है।',
  pa_quiet_title: 'चुपचाप एंट्री',
  pa_quiet_sub: 'सरप्राइज़ विज़िट — गेट पर एंट्री होने पर फ़्लैट को सूचना न दें।',
  pa_expected_on: 'कब आएँगे',
  pa_when_today: 'आज',
  pa_when_tomorrow: 'कल',
  pa_when_pickdate: 'तारीख़ चुनें',
  pa_date: 'तारीख़',
  pa_for_next: 'अगले',
  pa_n_days: '{n} दिन',
  pa_arrives_around: 'लगभग आने का समय',
  pa_starts_at: 'शुरू',
  pa_daily_window: 'रोज़ का समय',
  pa_valid_for_next: 'अगले कितने समय तक',
  pa_24_hours: '24 घंटे',
  pa_one_hour: '1 घंटा',
  pa_n_hours: '{n} घंटे',
  pa_daily_note: 'वे हर दिन आने के समय से इतने घंटों तक अंदर आ सकते हैं।',
  pa_send_code_title: 'अप्रूवल कोड भेजें',
  pa_send_code_sub: 'विज़िटर को गेट पर दिखाने के लिए SMS से 6 अंकों का कोड मिलेगा।',
  pa_notes: 'नोट (ज़रूरी नहीं)',
  pa_notes_ph: 'गार्ड को जो बताना हो',
  pa_submit: 'विज़िटर प्री-अप्रूव करें',
  pa_submit_named: '{name} को प्री-अप्रूव करें',
  pa_err_time: 'प्री-अप्रूव करने से पहले सही शुरू का समय डालें (जैसे 6:00 PM)।',
  pa_err_generic: 'पास नहीं बन सका। इंटरनेट देखकर फिर से कोशिश करें।',
  pa_err_unavailable: 'प्री-अप्रूवल अभी उपलब्ध नहीं है। थोड़ी देर में फिर कोशिश करें।',
  pa_err_details: 'पास नहीं बन सका। जानकारी जाँचकर फिर से कोशिश करें।',
  pa_err_conflict: 'यह पास अभी नहीं बन सका। रिफ़्रेश करके फिर कोशिश करें।',

  // profile tab
  profile_title: 'प्रोफ़ाइल',
  profile_edit: 'प्रोफ़ाइल बदलें',
  profile_verified: 'सत्यापित रेज़िडेंट',
  role_owner: 'मालिक',
  role_tenant: 'किराएदार',
  role_family: 'परिवार का सदस्य',
  role_committee_admin: 'कमेटी एडमिन',
  role_master_admin: 'मास्टर एडमिन',
  sec_account: 'खाता',
  sec_notifications: 'नोटिफ़िकेशन',
  sec_community_safety: 'कम्युनिटी और सुरक्षा',
  sec_preferences: 'सेटिंग्स',
  sec_support: 'सहायता',
  sec_management: 'प्रबंधन',
  row_personal_info: 'निजी जानकारी',
  row_my_flat: 'मेरा फ़्लैट',
  row_family: 'परिवार',
  row_vehicles: 'गाड़ियाँ',
  row_notif_inbox: 'नोटिफ़िकेशन इनबॉक्स',
  row_residents: 'रेज़िडेंट',
  row_visitor_history: 'विज़िटर हिस्ट्री',
  row_emergency_sos: 'इमरजेंसी SOS',
  row_appearance: 'दिखावट',
  appearance_dark: 'डार्क',
  appearance_light: 'लाइट',
  row_privacy: 'प्राइवेसी',
  row_help: 'मदद और सवाल-जवाब',
  row_contact: 'सपोर्ट से संपर्क',
  row_terms: 'शर्तें और प्राइवेसी',
  row_about: 'बारे में',
  row_society_admin: 'सोसाइटी एडमिन',
  row_committee_desk: 'कमेटी डेस्क',
  row_pending_actions: 'बाकी काम',
  row_shared_access: 'साझा एक्सेस',
  logout: 'लॉग आउट',

  // language picker
  lang_title: 'भाषा',
  lang_error: 'भाषा बदली नहीं जा सकी। फिर से कोशिश करें।',
  lang_soon: 'जल्द आ रही है',
  lang_footer: 'और भाषाएँ जल्द आ रही हैं।',

  // notification settings
  np_title: 'नोटिफ़िकेशन सेटिंग्स',
  np_empty_title: 'सेटिंग्स उपलब्ध नहीं',
  np_empty_body: 'अभी आपकी नोटिफ़िकेशन सेटिंग्स लोड नहीं हो पाईं। थोड़ी देर में फिर कोशिश करें।',
  np_always_on: 'सुरक्षा और SOS अलर्ट हमेशा चालू रहते हैं और बंद नहीं किए जा सकते।',
  np_update_error: 'सेटिंग बदली नहीं जा सकी। फिर से कोशिश करें।',
  np_categories: 'श्रेणियाँ',
  np_push: 'पुश',
  np_email: 'ईमेल',
  np_push_a11y: '{cat} पुश नोटिफ़िकेशन',
  np_email_a11y: '{cat} ईमेल नोटिफ़िकेशन',
  np_cat_notices: 'सूचनाएँ',
  np_cat_visitors: 'विज़िटर और सुरक्षा',
  np_cat_payments: 'पेमेंट',
  np_cat_events: 'इवेंट',
  np_cat_polls: 'पोल',
  np_cat_community: 'कम्युनिटी',
  np_gate_tone: 'गेट टोन',
  np_gate_tone_sub: 'जब कोई विज़िटर आपकी मंज़ूरी का इंतज़ार करता है तब बजने वाली आवाज़।',
  np_tone_dingdong: 'डिंग-डॉंग',
  np_tone_dingdong_sub: 'क्लासिक डोरबेल — डिफ़ॉल्ट',
  np_tone_chime: 'चाइम',
  np_tone_chime_sub: 'तीन सुरों वाली चमकीली घंटी',
  np_tone_marimba: 'मरिम्बा',
  np_tone_marimba_sub: 'लकड़ी की तेज़ धुन — सबसे हल्की',
  np_tone_ring: 'रिंग',
  np_tone_ring_sub: 'टेलीफ़ोन की घंटी — सबसे तेज़',
  np_tone_a11y: '{name} गेट टोन',
  np_play: 'बजाएँ',
  np_play_a11y: '{name} बजाएँ',

  // common (added tranche 5)
  search: 'खोजें',

  // community tab
  ct_tab_notices: 'सूचनाएँ',
  ct_tab_discussions: 'चर्चा',
  ct_tab_polls: 'पोल',
  ct_tab_events: 'इवेंट',
  ct_tab_issues: 'शिकायतें',
  ml_vendors: 'वेंडर',
  ml_classifieds: 'क्लासिफ़ाइड',
  ml_lost_found: 'खोया-पाया',
  ml_celebrations: 'जश्न',
  ct_check_connection: 'अपना इंटरनेट देखकर फिर से कोशिश करें।',
  notice_kind_urgent: 'ज़रूरी',
  notice_kind_event: 'इवेंट',
  notice_kind_committee: 'कमेटी',
  notice_kind_general: 'सामान्य',
  ct_notices_err_title: 'सूचनाएँ लोड नहीं हो सकीं',
  ct_notices_empty_title: 'अभी कोई सूचना नहीं',
  ct_notices_empty_body: 'आपकी कमेटी की सूचनाएँ यहाँ दिखेंगी।',
  ct_pinned: 'पिन किया',
  ct_all_notices: 'सभी सूचनाएँ',
  ct_disc_err_title: 'चर्चाएँ लोड नहीं हो सकीं',
  ct_disc_empty_title: 'अभी कोई चर्चा नहीं',
  ct_disc_empty_body: 'अपनी कम्युनिटी से कोई चर्चा शुरू करें, वह यहाँ दिखेगी।',
  ct_reply: '1 जवाब',
  ct_replies: '{n} जवाब',
  ct_views: '{n} व्यू',
  ct_nothing_here: 'यहाँ कुछ नहीं',
  ct_disc_none_body: 'इस टैग की कोई चर्चा अभी नहीं है।',
  ct_polls_err_title: 'पोल लोड नहीं हो सके',
  ct_active_polls: 'चालू पोल',
  ct_see_all: 'सभी देखें →',
  ct_polls_empty_title: 'कोई चालू पोल नहीं',
  ct_polls_empty_body: 'जब कमेटी कोई पोल शुरू करेगी, वह यहाँ दिखेगा।',
  ct_anonymous: 'गुमनाम',
  ct_voted: '{total} में से {n} ने वोट किया',
  poll_all_wings: 'सभी विंग',
  poll_wing: 'विंग {code}',
  poll_closed: 'बंद',
  poll_open: 'खुला',
  poll_closes_today: 'आज बंद होगा',
  poll_closes_tomorrow: 'कल बंद होगा',
  poll_closes_in: '{n} दिन में बंद होगा',
  ct_events_err_title: 'इवेंट लोड नहीं हो सके',
  ct_events_empty_title: 'अभी कोई इवेंट नहीं',
  ct_events_empty_body: 'सोसाइटी के आने वाले इवेंट यहाँ दिखेंगे।',
  ct_upcoming: 'आने वाले',
  ct_no_upcoming: 'अभी कोई आने वाला इवेंट नहीं।',
  ct_past: 'पिछले',
  ct_issues_err_title: 'शिकायतें लोड नहीं हो सकीं',
  ct_community_issues: 'कम्युनिटी शिकायतें',
  ct_issues_empty_title: 'कोई कम्युनिटी शिकायत नहीं',
  ct_issues_empty_body: 'पूरी कम्युनिटी के लिए उठाई गई शिकायतें यहाँ दिखेंगी।',
  ct_comments: '{n} कमेंट',
  ct_select_subtab: 'ऊपर से कोई सब-टैब चुनें — उसका कंटेंट दाईं ओर पैनल में खुलेगा।',
  ct_select_notice_title: 'कोई सूचना चुनें',
  ct_select_notice_body: 'पढ़ने के लिए लिस्ट से कोई सूचना चुनें।',
  ct_acknowledged: 'पढ़ लिया',
  ct_ack_count: '{n} ने पढ़ा',

  // pay tab
  pay_title: 'पेमेंट',
  pay_how_to_pay: 'पेमेंट कैसे करें',
  pay_bank: 'बैंक',
  pay_account: 'खाता',
  pay_how_to_pay_note: 'अपने बैंक या UPI ऐप से नोट में अपना फ़्लैट नंबर डालकर पेमेंट करें। सोसाइटी का ट्रेज़रर इसे दर्ज करता है और आपका बिल यहाँ PAID हो जाता है।',
  pay_record_hdr: 'पेमेंट दर्ज करें · ट्रेज़रर',
  pay_no_unpaid: 'कोई बकाया बिल नहीं — सब दर्ज हो चुका है।',
  pay_the_flat: 'फ़्लैट',
  pay_flat: 'फ़्लैट',
  pay_recorded_ok: '{flat} से {amount} दर्ज किया — बिल पेड मार्क हुआ।',
  pay_record_error: 'पेमेंट दर्ज नहीं हो सका।',
  pay_due: 'देय {date}',
  pay_includes_late: '{amount} लेट फ़ीस शामिल',
  pay_received: 'मिल गया',
  pay_err_title: 'पेमेंट उपलब्ध नहीं',
  pay_err_body: 'अभी आपका बिल लोड नहीं हो पाया। इंटरनेट देखकर फिर से कोशिश करें।',
  pay_no_dues_title: 'अभी कोई बकाया नहीं',
  pay_no_dues_body: 'इस महीने का कोई बिल नहीं है। अगले महीने देखें, या नीचे अपनी बिल हिस्ट्री देखें।',
  pay_fully_paid: '{month} पूरा भुगतान हो गया',
  pay_recorded_on: '{date} को दर्ज',
  pay_no_outstanding: 'कोई बकाया नहीं',
  pay_view_breakdown: 'ब्रेकडाउन देखें',
  pay_past_bills: 'पिछले बिल',
  pay_recent_bills: 'हाल के बिल',
  pay_view_all: 'सभी देखें →',
  pay_no_history: 'अभी कोई पेमेंट हिस्ट्री नहीं।',
  pay_breakdown: '{month} का ब्रेकडाउन',
  pay_subtotal: 'सबटोटल',
  pay_late_fee: 'लेट फ़ीस',
  pay_total_due: 'कुल देय',
  pay_record_title: '{flat} से {amount} दर्ज करें',
  pay_record_sub: '{month} · रसीदें ट्रेज़रर द्वारा दर्ज होती हैं (बाय-लॉ 113) और सोसाइटी के ऑडिट रिकॉर्ड में आती हैं।',
  pay_received_via: 'किससे मिला',
  pay_method_cash: 'नकद',
  pay_method_cheque: 'चेक',
  pay_method_card: 'कार्ड',
  pay_reference: 'रेफ़रेंस',
  pay_reference_help: 'UTR / चेक नंबर — ज़रूरी नहीं पर हिसाब के लिए अच्छा',
  pay_recording: 'दर्ज हो रहा है…',
  pay_record_received: 'मिला हुआ दर्ज करें',
  pay_due_by: '{date} तक देय',
  pay_invoice_label: 'इनवॉइस',
  pay_overdue_since: '{date} से बकाया',
  pay_plus_late: '+ लेट फ़ीस',
  pay_col_invoice: 'इनवॉइस',
  pay_col_period: 'अवधि',
  pay_col_amount: 'रकम',
  pay_col_status: 'स्थिति',

  // bills & receipts history
  bh_title: 'बिल और रसीदें',
  bh_err_title: 'बिल उपलब्ध नहीं',
  bh_err_body: 'अभी आपकी बिल हिस्ट्री लोड नहीं हो पाई। थोड़ी देर में फिर कोशिश करें।',
  bh_empty_title: 'अभी कोई बिल नहीं',
  bh_empty_body: 'आपके महीने के मेंटेनेंस बिल बनने पर यहाँ दिखेंगे।',
  bh_paid_in: '{year} में भुगतान',
  bh_streak: 'समय पर भुगतान',
  bh_months: '{n} महीने',
  bh_print_notice: 'प्रिंट करने के लिए अगला ऐप अपडेट चाहिए — वह नए बिल्ड के साथ आएगा।',
  bh_col_receipt: 'रसीद',
  bh_receipt: 'रसीद',
  bh_invoice: 'इनवॉइस',
  bh_download_a11y: '{month} {doc} डाउनलोड करें',
  bh_paid_on: '{date} को भुगतान',
  bh_incl_late: 'लेट फ़ीस शामिल',

  // helpdesk
  hd_title: 'हेल्पडेस्क',
  hd_open: 'खुले ({n})',
  hd_resolved: 'निपटे ({n})',
  hd_err_title: 'हेल्पडेस्क उपलब्ध नहीं',
  hd_err_body: 'अभी आपके टिकट लोड नहीं हो पाए। थोड़ी देर में फिर कोशिश करें।',
  hd_no_open: 'कोई खुला टिकट नहीं',
  hd_no_open_body: 'आपकी सभी समस्याएँ हल हो चुकी हैं। नया टिकट बनाने के लिए + दबाएँ।',
  hd_no_resolved: 'कोई निपटा टिकट नहीं',
  hd_no_resolved_body: 'आप जो टिकट बंद करेंगे वे यहाँ दिखेंगे।',
  hd_how_moves: 'टिकट कैसे आगे बढ़ता है',
  hd_j_raised: 'दर्ज किया',
  hd_j_raised_sub: 'आप समस्या बताते हैं, फोटो जोड़ते हैं',
  hd_j_assigned: 'सौंपा गया',
  hd_j_assigned_sub: 'फैसिलिटी मैनेजर वेंडर चुनता है',
  hd_j_resolved: 'हल + रेटिंग',
  hd_j_resolved_sub: 'आप पुष्टि करते हैं और काम को रेट करते हैं',
  hd_new_ticket: 'नया टिकट',
  hd_updated: '{time} को अपडेट',
  hd_category: 'श्रेणी',
  hd_field_title: 'शीर्षक',
  hd_title_help: 'छोटा रखें — ज़्यादा से ज़्यादा 100 अक्षर।',
  hd_title_ph: 'जैसे किचन का सिंक लीक हो रहा है',
  hd_description: 'विवरण',
  hd_desc_ph: 'बताएँ क्या और कहाँ गड़बड़ है।',
  hd_photos: 'फोटो',
  hd_location: 'जगह',
  hd_loc_personal: 'निजी (मेरा फ़्लैट)',
  hd_loc_common: 'कॉमन एरिया',
  hd_priority: 'प्राथमिकता',
  hd_prio_normal: 'सामान्य',
  hd_prio_urgent: 'ज़रूरी',
  hd_raise_error: 'टिकट दर्ज नहीं हो सका। फिर से कोशिश करें।',
  hd_raise: 'टिकट दर्ज करें',
  hd_details: 'टिकट विवरण',
  hd_detail_err_title: 'टिकट उपलब्ध नहीं',
  hd_detail_err_body: 'यह टिकट हटाया जा चुका हो सकता है, या लोड करते समय कुछ गड़बड़ हुई।',
  hd_raised_by: 'किसने दर्ज किया',
  hd_you: 'आप',
  hd_raised_on: 'कब दर्ज किया',
  hd_assigned_to: 'किसे सौंपा',
  hd_not_assigned: 'अभी सौंपा नहीं',
  hd_expected_by: 'कब तक',
  hd_tbc: 'बाद में तय होगा',
  hd_timeline: 'प्रगति टाइमलाइन',
  hd_status_updated: 'स्थिति अपडेट हुई',
  hd_commented: '{author} ने कमेंट किया',
  hd_awaiting: 'हल होने का इंतज़ार',
  hd_pending: 'पूरा होना बाकी',
  hd_comment_error: 'आपका कमेंट पोस्ट नहीं हो सका। फिर से कोशिश करें।',
  hd_attach_photo: 'फोटो जोड़ें',
  hd_add_comment: 'कमेंट जोड़ें…',
  hd_send_comment: 'कमेंट भेजें',
  hd_cat_plumbing: 'प्लंबिंग',
  hd_cat_electrical: 'बिजली',
  hd_cat_security: 'सुरक्षा',
  hd_cat_lift: 'लिफ्ट',
  hd_cat_pest: 'पेस्ट कंट्रोल',
  hd_cat_cleaning: 'सफ़ाई',
  hd_cat_other: 'अन्य',

  // amenity booking
  am_title: 'सुविधा बुक करें',
  am_my_bookings: 'मेरी बुकिंग',
  am_err_title: 'सुविधाएँ उपलब्ध नहीं',
  am_err_body: 'अभी सुविधाओं के स्लॉट लोड नहीं हो पाए। थोड़ी देर में फिर कोशिश करें।',
  am_empty_title: 'कोई सुविधा सेट नहीं है',
  am_empty_body: 'आपकी सोसाइटी ने अभी कोई बुक करने योग्य सुविधा नहीं बनाई है।',
  am_per_slot: '/स्लॉट',
  am_today_date: 'आज · {date}',
  am_open: 'खाली',
  am_taken: 'बुक',
  am_rules: 'नियम',
  am_confirm: 'बुकिंग पक्की करें',
  am_booked_by: '{name} ने बुक किया',
  am_you: 'आप',
  am_charges: 'शुल्क',
  am_free: 'मुफ़्त',
  am_conflict: 'यह स्लॉट अभी किसी और ने बुक कर लिया। दूसरा चुनें।',
  am_book_error: 'यह स्लॉट बुक नहीं हो सका। फिर से कोशिश करें।',
  am_slot_booked: 'स्लॉट बुक हो गया',
  am_view_bookings: 'मेरी बुकिंग देखें',
  am_done: 'हो गया',

  // venue booking
  vb_title: 'वेन्यू बुक करें',
  vb_err_title: 'वेन्यू उपलब्ध नहीं',
  vb_err_body: 'अभी बुक करने योग्य वेन्यू लोड नहीं हो पाए। थोड़ी देर में फिर कोशिश करें।',
  vb_empty_title: 'कोई वेन्यू सेट नहीं है',
  vb_empty_body: 'आपकी सोसाइटी ने अभी पूरे दिन के लिए कोई वेन्यू नहीं बनाया है।',
  vb_booked: 'वेन्यू बुक हो गया',
  vb_submitted: 'बुकिंग रिक्वेस्ट भेजी गई',
  vb_confirmed: 'आपकी बुकिंग पक्की हो गई।',
  vb_pending: 'एडमिन की पुष्टि बाकी है। समीक्षा के बाद यह "मेरी बुकिंग" में दिखेगी।',
  vb_book_another: 'दूसरी तारीख़ बुक करें',
  vb_choose_venue: 'वेन्यू चुनें',
  vb_up_to: '{n} दिन पहले तक',
  vb_pick_day: 'पूरा दिन चुनें',
  vb_purpose: 'मकसद',
  vb_purpose_help: 'कमेटी को बताएँ कि वेन्यू किस लिए है।',
  vb_purpose_ph: 'जैसे बेटी की बर्थडे पार्टी',
  vb_info: 'हर तारीख़ पर हर वेन्यू की एक ही पूरे दिन की बुकिंग। पहले से बुक तारीख़ें धुंधली दिखती हैं।',
  vb_conflict: 'यह तारीख़ इस वेन्यू के लिए अभी किसी और ने ले ली। दूसरी चुनें।',
  vb_submit_error: 'बुकिंग भेजी नहीं जा सकी। फिर से कोशिश करें।',
  vb_request: 'बुकिंग रिक्वेस्ट करें',

  // my bookings
  mb_err_title: 'बुकिंग उपलब्ध नहीं',
  mb_err_body: 'अभी आपकी बुकिंग लोड नहीं हो पाईं। थोड़ी देर में फिर कोशिश करें।',
  mb_empty_title: 'अभी कोई बुकिंग नहीं',
  mb_empty_body: 'आप जो सुविधा स्लॉट और वेन्यू बुक करेंगे वे यहाँ दिखेंगे।',
  mb_venues_for_functions: 'फंक्शन के लिए वेन्यू',
  mb_cancel_error: 'यह बुकिंग रद्द नहीं हो सकी। फिर से कोशिश करें।',
  mb_up_to_guests: '{n} मेहमानों तक',
  mb_days_ahead: '{n} दिन पहले',
  mb_amenity: 'सुविधा',
  mb_venue: 'वेन्यू',
  mb_cancel_confirm: 'यह बुकिंग रद्द करें?',
  mb_keep: 'रहने दें',
  mb_yes_cancel: 'हाँ, रद्द करें',
  mb_cancel_booking: 'बुकिंग रद्द करें',

  // residents directory
  res_search_ph: 'नाम या फ़्लैट से खोजें',
  res_wing: '{w} विंग',
  res_err_title: 'डायरेक्टरी उपलब्ध नहीं',
  res_err_body: 'अभी रेज़िडेंट डायरेक्टरी लोड नहीं हो पाई। थोड़ी देर में फिर कोशिश करें।',
  res_empty_title: 'अभी कोई रेज़िडेंट नहीं',
  res_empty_body: 'आपकी सोसाइटी के मंज़ूर रेज़िडेंट यहाँ दिखेंगे।',
  res_privacy_note: 'रेज़िडेंट खुद तय करते हैं क्या शेयर करना है। कुछ जानकारी छिपी हो सकती है।',
  res_no_matches: 'कुछ नहीं मिला',
  res_no_matches_body: 'कोई दूसरा नाम, फ़्लैट या विंग आज़माएँ।',
  res_private: 'निजी',

  // family & passes
  fp_title: 'परिवार और पास',
  fp_add: 'परिवार सदस्य जोड़ें',
  fp_permanent: 'स्थायी पास',
  fp_note: 'स्थायी पास वाले परिवार हर बार बिना मंज़ूरी अंदर आते हैं।',
  fp_err_title: 'परिवार और पास उपलब्ध नहीं',
  fp_err_body: 'अभी आपकी परिवार लिस्ट लोड नहीं हो पाई। थोड़ी देर में फिर कोशिश करें।',
  fp_empty_title: 'अभी कोई परिवार सदस्य नहीं',
  fp_empty_body: 'परिवार जोड़ें ताकि वे हर बार बिना मंज़ूरी अंदर आ सकें।',
  fp_add_error: 'यह सदस्य अभी जोड़ा नहीं जा सका। थोड़ी देर में फिर कोशिश करें।',
  fp_schedules: 'शेड्यूल',
  fp_pass_active: 'पास चालू',
  fp_pending: 'बाकी',
  fp_relation: 'रिश्ता',
  fp_relation_ph: 'पति/पत्नी, माता-पिता, बच्चा…',
  fp_is_kid: 'यह बच्चा है (नियमित शेड्यूल चाहिए)',
  fp_is_kid_short: 'यह बच्चा है',
  fp_add_member: 'सदस्य जोड़ें',

  // kids permissions
  kp_title: 'बच्चों की अनुमतियाँ',
  kp_add_window: 'विंडो जोड़ें',
  kp_allow_now: 'मेरे बच्चे को अभी बाहर जाने दें',
  kp_allow_now_sub: 'एक-बार की अनुमति — गेट उन्हें समय के अंदर बाहर जाने देता है।',
  kp_child_name: 'बच्चे का नाम',
  kp_allow_named: '{name} को {h} घंटे बाहर जाने दें',
  kp_allow_out: 'बाहर जाने दें',
  kp_info: 'इन नियमित समयों में बच्चों को अपने आप बाहर जाने दिया जाता है। गार्ड को पहले से पता चल जाता है।',
  kp_err_title: 'बच्चों की अनुमतियाँ उपलब्ध नहीं',
  kp_err_body: 'ये अभी लोड नहीं हो पाईं। थोड़ी देर में फिर कोशिश करें।',
  kp_empty_title: 'कोई नियमित विंडो नहीं',
  kp_empty_body: 'स्कूल पिकअप या क्लास जैसी नियमित विंडो जोड़ें ताकि वह अपने आप मंज़ूर हो।',
  kp_toggle_error: 'यह विंडो अपडेट नहीं हो सकी। फिर से कोशिश करें।',
  kp_allow_error: 'बाहर जाने की अनुमति नहीं बन सकी। थोड़ी देर में फिर कोशिश करें।',
  kp_save_error: 'बदलाव सेव नहीं हो सके। थोड़ी देर में फिर कोशिश करें।',
  kp_add_error: 'यह विंडो अभी जोड़ी नहीं जा सकी। थोड़ी देर में फिर कोशिश करें।',
  kp_remove_error: 'यह विंडो हटाई नहीं जा सकी। थोड़ी देर में फिर कोशिश करें।',
  kp_child: 'बच्चा',
  kp_edit_window: 'नियमित विंडो बदलें',
  kp_add_recurring: 'नियमित विंडो जोड़ें',
  kp_kid_ph: 'जैसे आन्या',
  kp_activity: 'गतिविधि',
  kp_activity_ph: 'जैसे स्कूल बस',
  kp_schedule: 'शेड्यूल',
  kp_schedule_ph: 'सोम–शुक्र · 7:30–8:00 AM',
  kp_escort: 'साथ में कौन',
  kp_escort_ph: 'ब्राइट फ्यूचर स्कूल',
  kp_save: 'बदलाव सेव करें',
  kp_remove: 'यह विंडो हटाएँ',

  // move-in / move-out
  mo_title: 'शिफ़्टिंग रिक्वेस्ट',
  mo_request_type: 'रिक्वेस्ट का प्रकार',
  mo_movein: 'मूव-इन',
  mo_moveout: 'मूव-आउट',
  mo_preferred_date: 'पसंदीदा तारीख़',
  mo_time_slot: 'समय स्लॉट',
  mo_vehicle: 'सामान की गाड़ी नंबर',
  mo_helpers: 'मददगारों की संख्या',
  mo_notes: 'नोट (ज़रूरी नहीं)',
  mo_notes_ph: 'लिफ्ट बुकिंग, नाज़ुक सामान, आदि',
  mo_deposit: 'वापसी योग्य जमा',
  mo_applies: 'लागू है',
  mo_lift: 'सर्विस लिफ्ट बुकिंग',
  mo_included: 'शामिल है',
  mo_approval: 'कमेटी की मंज़ूरी',
  mo_required: 'ज़रूरी है',
  mo_submitted: '{type} रिक्वेस्ट एडमिन की मंज़ूरी के लिए भेजी गई।',
  mo_err_details: 'रिक्वेस्ट भेजी नहीं जा सकी। तारीख़ और समय स्लॉट जाँचकर फिर से कोशिश करें।',
  mo_err_generic: 'रिक्वेस्ट अभी भेजी नहीं जा सकी। थोड़ी देर में फिर कोशिश करें।',
  mo_submit: 'रिक्वेस्ट भेजें',
  mo_your_requests: 'आपकी रिक्वेस्ट',
  mo_no_requests: 'अभी कोई शिफ़्टिंग रिक्वेस्ट नहीं।',
  mo_request_title: '{type} रिक्वेस्ट',
  mo_date: 'तारीख़',
  mo_goods_vehicle: 'सामान की गाड़ी',
  mo_helpers_label: 'मददगार',
  mo_submitted_label: 'भेजी गई',
  mo_waiting: 'कमेटी की मंज़ूरी का इंतज़ार। मंज़ूर होने तक आप रद्द कर सकते हैं।',
  mo_cancel: 'यह रिक्वेस्ट रद्द करें',
  mo_cancel_error: 'यह रिक्वेस्ट रद्द नहीं हो सकी। थोड़ी देर में फिर कोशिश करें।',

  // attendance
  at_title: 'हाज़िरी',
  at_prev_month: 'पिछला महीना',
  at_next_month: 'अगला महीना',
  at_err_title: 'हाज़िरी उपलब्ध नहीं',
  at_err_body: 'अभी हाज़िरी का रिकॉर्ड लोड नहीं हो पाया।',
  at_empty_title: 'इस महीने कोई एंट्री नहीं',
  at_empty_body: '{month} के लिए अभी कोई इन/आउट रिकॉर्ड नहीं।',
  at_no_records: 'इस महीने का कोई रिकॉर्ड नहीं।',
  at_absent: 'गैरहाज़िर',

  // vehicles
  veh_title: 'मेरी गाड़ियाँ',
  veh_add: 'गाड़ी जोड़ें',
  veh_car: 'कार',
  veh_two_wheeler: 'दोपहिया',
  veh_other: 'अन्य',
  veh_plate_error: 'गाड़ी का नंबर प्लेट डालें।',
  veh_dup_error: 'यह नंबर आपकी सोसाइटी में पहले से दर्ज है।',
  veh_add_error: 'गाड़ी जोड़ी नहीं जा सकी। इंटरनेट देखकर फिर से कोशिश करें।',
  veh_err_title: 'गाड़ियाँ उपलब्ध नहीं',
  veh_err_body: 'अभी आपकी गाड़ियाँ लोड नहीं हो पाईं। थोड़ी देर में फिर कोशिश करें।',
  veh_empty_title: 'अभी कोई गाड़ी नहीं',
  veh_empty_body: 'अपनी कार या दोपहिया दर्ज करें ताकि गेट उसे पहचान ले।',
  veh_add_cta: 'गाड़ी जोड़ें',
  veh_sticker: 'पार्किंग स्टिकर',
  veh_plate: 'नंबर प्लेट',
  veh_type: 'प्रकार',
  veh_model: 'मॉडल (ज़रूरी नहीं)',
  veh_model_ph: 'जैसे हुंडई क्रेटा · सफ़ेद',
  veh_sticker_field: 'पार्किंग स्टिकर (ज़रूरी नहीं)',
  veh_sticker_ph: 'जैसे A-601-C1',

  // delivery auto-approval PIN
  dp_title: 'डिलीवरी ऑटो-अप्रूवल',
  dp_err_title: 'डिलीवरी PIN उपलब्ध नहीं',
  dp_err_body: 'अभी आपका गेट PIN लोड नहीं हो पाया। थोड़ी देर में फिर कोशिश करें।',
  dp_auto_approve: 'डिलीवरी अपने आप मंज़ूर करें',
  dp_auto_approve_sub: 'डिलीवरी वाले गेट पर आपका PIN डालकर आपको बिना परेशान किए अंदर आ जाते हैं।',
  dp_rotates: 'हर महीने बदलता है',
  dp_generating: 'बन रहा है…',
  dp_regenerate: 'नया PIN बनाएँ',
  dp_warn: 'सिर्फ़ भरोसेमंद डिलीवरी ऐप के साथ शेयर करें। हर इस्तेमाल फोटो के साथ दर्ज होता है।',
  dp_regenerated: 'नया PIN बन गया। पुराना PIN तुरंत बंद हो जाता है।',
  dp_regen_error: 'PIN अभी दोबारा नहीं बन सका।',

  // message the gate
  mg_title: 'गेट को संदेश भेजें',
  mg_info: 'सीधे गार्ड डेस्क पर जाता है। इमरजेंसी के लिए SOS इस्तेमाल करें — यह रोज़मर्रा के निर्देशों के लिए है।',
  mg_placeholder: 'जैसे फर्नीचर टेम्पो करीब 5 बजे आ रहा है — कृपया उसे सर्विस लिफ्ट तक आने दें।',
  mg_send_error: 'यह भेजा नहीं जा सका। थोड़ी देर में फिर कोशिश करें।',
  mg_send: 'गेट पर भेजें',
  mg_sent: 'भेजे गए',
  mg_empty_title: 'अभी कुछ नहीं भेजा',
  mg_empty_body: 'आप गेट को जो नोट भेजेंगे वे यहाँ देखे-गए स्थिति के साथ दिखेंगे।',

  // party invite
  pi_title: 'पार्टी न्योता',
  pi_intro: 'पूरे आयोजन के लिए एक ही लिंक — हर मेहमान उसे टैप करके अपना गेट पास पाता है।',
  pi_occasion: 'क्या मौका है?',
  pi_occasion_ph: 'जैसे आरव का जन्मदिन',
  pi_when: 'कब',
  pi_open_for: 'कितनी देर खुला',
  pi_guest_limit: 'मेहमानों की सीमा',
  pi_n_guests: '{n} मेहमान',
  pi_create_named: '{title} के लिए न्योता बनाएँ',
  pi_create: 'न्योता बनाएँ',
  pi_your_invites: 'आपके न्योते',
  pi_empty_title: 'अभी कोई न्योता नहीं',
  pi_empty_body: 'ऊपर एक बनाएँ — जन्मदिन, पूजा और घर की पार्टियों के लिए बढ़िया।',
  pi_claimed: '{total} में से {n} पास लिए गए',
  pi_copied: 'लिंक कॉपी हुआ',
  pi_share: 'लिंक शेयर करें',
  pi_cancelling: 'रद्द हो रहा है…',
  pi_time_error: 'सही शुरू का समय डालें (जैसे 6:00 PM)।',
  pi_created: 'न्योता बन गया — लिंक अपने मेहमानों के साथ शेयर करें।',
  pi_create_error: 'न्योता अभी नहीं बन सका। थोड़ी देर में फिर कोशिश करें।',
  pi_cancel_error: 'यह न्योता रद्द नहीं हो सका। थोड़ी देर में फिर कोशिश करें।',

  // classifieds
  cl_err_title: 'क्लासिफ़ाइड लोड नहीं हो सके',
  cl_err_body: 'लिस्टिंग लाते समय कुछ गड़बड़ हुई। अपना इंटरनेट देखकर फिर से कोशिश करें।',
  cl_empty_title: 'अभी कोई लिस्टिंग नहीं',
  cl_empty_body: 'रेज़िडेंट जो चीज़ें बेचना या देना चाहते हैं वे यहाँ दिखेंगी।',

  // lost & found
  lf_err_title: 'खोया-पाया लोड नहीं हो सका',
  lf_err_body: 'चीज़ें लाते समय कुछ गड़बड़ हुई। अपना इंटरनेट देखकर फिर से कोशिश करें।',
  lf_empty_title: 'कुछ भी रिपोर्ट नहीं',
  lf_empty_body: 'रेज़िडेंट द्वारा बताई गई खोई या मिली चीज़ें यहाँ दिखेंगी।',

  // celebrations
  bd_share: 'मेरे जश्न शेयर करें',
  bd_share_sub: 'पड़ोसी आपके खास दिनों पर आपको बधाई दे सकते हैं।',
  bd_err_title: 'जश्न लोड नहीं हो सके',
  bd_err_body: 'जश्न लाते समय कुछ गड़बड़ हुई। अपना इंटरनेट देखकर फिर से कोशिश करें।',
  bd_empty_title: 'इस हफ़्ते कोई जश्न नहीं',
  bd_empty_body: 'सोसाइटी में जन्मदिन और सालगिरह यहाँ दिखेंगे।',
  bd_this_week: 'इस हफ़्ते',
  bd_wished_count: '{n} ने बधाई दी',
  bd_wished: 'बधाई दी',
  bd_wish: 'बधाई दें',

  // personal info
  pinfo_name_error: 'अपना पूरा नाम डालें।',
  pinfo_save_error: 'आपकी प्रोफ़ाइल अभी सेव नहीं हो सकी। थोड़ी देर में फिर कोशिश करें।',
  pinfo_change_photo: 'फोटो बदलें',
  pinfo_photo_unavailable: 'फोटो अपलोड अभी उपलब्ध नहीं है।',
  pinfo_phone: 'फ़ोन',
  pinfo_email_help: 'ईमेल नहीं बदला जा सकता — यही आपका साइन-इन है।',
  pinfo_show_phone: 'रेज़िडेंट डायरेक्टरी में मेरा फ़ोन दिखाएँ',
  pinfo_visible: 'दिखाएँ',
  pinfo_flat_note: 'फ़्लैट और मालिकाना जानकारी आपकी सोसाइटी एडमिन संभालती है।',

  // change password
  cp_title: 'पासवर्ड बदलें',
  cp_current: 'मौजूदा पासवर्ड',
  cp_new: 'नया पासवर्ड',
  cp_confirm: 'नया पासवर्ड फिर से डालें',
  cp_update: 'पासवर्ड अपडेट करें',
  cp_current_error: 'अपना मौजूदा पासवर्ड डालें।',
  cp_weak: 'कम से कम 8 अक्षर और एक अंक।',
  cp_mismatch: 'पासवर्ड मेल नहीं खाते।',
  cp_wrong_current: 'मौजूदा पासवर्ड गलत है।',
  cp_generic_error: 'पासवर्ड अभी अपडेट नहीं हो सका।',
  cp_done_title: 'पासवर्ड अपडेट हो गया',
  cp_done_body: 'अगली बार साइन इन करते समय अपना नया पासवर्ड इस्तेमाल करें।',

  // deactivate account
  da_title: 'खाता बंद करें',
  da_your_flat: 'आपके फ़्लैट',
  da_password_error: 'पुष्टि के लिए अपना पासवर्ड डालें।',
  da_wrong_password: 'पासवर्ड गलत है।',
  da_generic_error: 'रिक्वेस्ट अभी भेजी नहीं जा सकी। थोड़ी देर में फिर कोशिश करें।',
  da_heading: 'खाता बंद करने की रिक्वेस्ट',
  da_body: 'आपकी सोसाइटी एडमिन इस रिक्वेस्ट की समीक्षा करेंगी। मंज़ूर होने पर आप {flat} के लिए सूचनाएँ, पेमेंट और गेट सुविधाओं का एक्सेस खो देंगे। पहले बकाया चुकाना ज़रूरी है।',
  da_reason: 'कारण (ज़रूरी नहीं)',
  da_reason_ph: 'शिफ़्ट हो रहे हैं, फ़्लैट बेच रहे हैं, आदि',
  da_confirm_pw: 'अपने पासवर्ड से पुष्टि करें',
  da_request: 'बंद करने की रिक्वेस्ट भेजें',

  // my flat
  mf_title: 'मेरा फ़्लैट',
  mf_err_title: 'फ़्लैट की जानकारी उपलब्ध नहीं',
  mf_err_body: 'अभी आपका फ़्लैट लोड नहीं हो पाया। थोड़ी देर में फिर कोशिश करें।',
  mf_registered: 'आपका दर्ज फ़्लैट',
  mf_ownership: 'मालिकाना',
  mf_carpet: 'कारपेट एरिया',
  mf_parking: 'पार्किंग',
  mf_residents: 'रेज़िडेंट और परिवार',
  mf_you: 'आप',

  // notifications inbox
  nb_mark_all: 'सभी पढ़ा चिह्नित करें',
  nb_read_error: 'पढ़ा चिह्नित नहीं हो सका। फिर से कोशिश करें।',
  nb_read_all_error: 'सभी पढ़ा चिह्नित नहीं हो सके। फिर से कोशिश करें।',
  nb_err_title: 'नोटिफ़िकेशन उपलब्ध नहीं',
  nb_err_body: 'अभी आपके नोटिफ़िकेशन लोड नहीं हो पाए। थोड़ी देर में फिर कोशिश करें।',
  nb_empty_title: 'सब देख लिया',
  nb_empty_body: 'मंज़ूरियाँ, सूचनाएँ और पेमेंट अपडेट यहाँ आएँगे।',

  // emergency contacts
  em_title: 'इमरजेंसी कॉन्टैक्ट',
  em_all_contacts: 'सभी कॉन्टैक्ट',
  em_security: 'सुरक्षा',
  em_no_guards: 'कोई गार्ड सूचीबद्ध नहीं',
  em_no_guards_body: 'आपकी सोसाइटी गेट स्टाफ़ जोड़ेगी तो वे यहाँ दिखेंगे।',
  em_guard_note: 'आपका गेट, एक टैप दूर — ड्यूटी पर मौजूद गार्ड को सीधे कॉल करें।',
  em_err_title: 'कॉन्टैक्ट उपलब्ध नहीं',
  em_err_body: 'अभी आपके इमरजेंसी कॉन्टैक्ट लोड नहीं हो पाए। थोड़ी देर में फिर कोशिश करें।',
  em_empty_title: 'कोई इमरजेंसी कॉन्टैक्ट नहीं',
  em_empty_body: 'यहाँ जोड़े गए कॉन्टैक्ट को SOS दबाने पर अपने आप कॉल जाता है।',
  em_sos_note: 'इन कॉन्टैक्ट को SOS दबाने पर अपने आप कॉल जाता है।',

  // society directory
  dir_flats: '{n} फ़्लैट',
  dir_residents: '{n} रेज़िडेंट',
  dir_empty_title: 'अभी यहाँ कुछ नहीं',
  dir_err_body: 'अभी सोसाइटी डायरेक्टरी लोड नहीं हो पाई। थोड़ी देर में फिर कोशिश करें।',
  dir_empty_body: 'सोसाइटी के कॉन्टैक्ट और विंग की जानकारी यहाँ दिखेगी।',
  dir_wings: 'विंग',
  dir_contacts: 'सोसाइटी कॉन्टैक्ट',
  dir_resident_dir: 'रेज़िडेंट डायरेक्टरी',

  // global search
  sr_back: 'वापस',
  sr_placeholder: 'सूचनाएँ, लोग, इवेंट खोजें…',
  sr_idle_title: 'अपनी सोसाइटी में खोजें',
  sr_idle_body: 'सूचनाएँ, इवेंट, वेंडर और रेज़िडेंट खोजें। कम से कम दो अक्षर टाइप करें।',
  sr_err_title: 'खोज उपलब्ध नहीं',
  sr_err_body: 'अभी खोज नहीं हो सकी। थोड़ी देर में फिर कोशिश करें।',
  sr_no_matches_body: '“{q}” के लिए कुछ नहीं मिला। कोई नाम, फ़्लैट या सूचना शीर्षक आज़माएँ।',

  // document vault
  doc_upload: 'अपलोड',
  doc_too_big: 'यह फ़ाइल 5 MB से बड़ी है — इसे कम करके फिर कोशिश करें।',
  doc_picker_error: 'फ़ाइल पिकर नहीं खुल सका।',
  doc_title_error: 'दस्तावेज़ को एक शीर्षक दें।',
  doc_uploaded: '“{name}” वॉल्ट में है।',
  doc_upload_error: 'अपलोड नहीं हो सका।',
  doc_removed: '“{name}” हटाया — ऑडिट रिकॉर्ड में दर्ज।',
  doc_remove_error: 'हटाया नहीं जा सका।',
  doc_err_title: 'दस्तावेज़ उपलब्ध नहीं',
  doc_err_body: 'अभी आपके दस्तावेज़ लोड नहीं हो पाए। थोड़ी देर में फिर कोशिश करें।',
  doc_empty_title: 'अभी कोई दस्तावेज़ नहीं',
  doc_empty_body: 'आपके साथ शेयर की गई रसीदें, सोसाइटी के पत्र और NOC यहाँ दिखेंगे।',
  doc_search_ph: 'दस्तावेज़ खोजें',
  doc_no_matches_body: '“{q}” से कोई दस्तावेज़ मेल नहीं खाता।',
  doc_remove: 'हटाएँ',
  doc_upload_hdr: 'वॉल्ट में अपलोड करें',
  doc_upload_sub: 'PDF या फोटो, 5 MB तक। हर सदस्य वॉल्ट पढ़ सकता है; अपलोड ऑडिट रिकॉर्ड में दर्ज होते हैं (बाय-लॉ 140(17))।',
  doc_change: 'बदलें',
  doc_choose_file: 'फ़ाइल चुनें',
  doc_title_field: 'शीर्षक',
  doc_title_ph: 'जैसे AGM 2025-26 मिनट्स (साइन किए)',
  doc_uploading: 'अपलोड हो रहा है…',
  doc_cat_minutes: 'मिनट्स',
  doc_cat_legal: 'कानूनी',
  doc_cat_certificate: 'सर्टिफ़िकेट',
  doc_cat_contract: 'कॉन्ट्रैक्ट',
  doc_cat_circular: 'सर्कुलर',
  doc_cat_finance: 'वित्त',
  doc_cat_general: 'सामान्य',

  // document viewer
  dv_title: 'दस्तावेज़',
  dv_download: 'डाउनलोड',
  dv_download_unavailable: 'डाउनलोड अभी उपलब्ध नहीं है।',
  dv_preview_soon: 'प्रीव्यू जल्द आ रहा है',
  dv_preview_soon_body: 'ऐप में प्रीव्यू अभी तैयार नहीं है — तब तक सोसाइटी ऑफ़िस से डाउनलोड करें।',

  // shared bits
  phatt_photos: 'फोटो',
  phatt_camera: 'कैमरा',
  phatt_choose: 'फोटो चुनें',
  phatt_remove: 'फोटो हटाएँ',
  phatt_cam_declined: 'कैमरे की अनुमति नहीं मिली।',
  phatt_read_error: 'यह फोटो पढ़ी नहीं जा सकी। कोई दूसरी आज़माएँ।',
  phatt_picker_error: 'फोटो पिकर नहीं खुल सका।',
  dc_busy: 'बुक',
  up_a11y: 'अपवोट',

  // relative time (timeAgo)
  time_now: 'अभी-अभी',
  time_m: '{n} मिनट पहले',
  time_h: '{n} घंटे पहले',
  time_d: '{n} दिन पहले',
  time_today: 'आज',
  time_yesterday: 'कल',

  // gate pass window labels (list row)
  gp_multi_entry: 'कई बार एंट्री',
  gp_single_entry: 'एक बार एंट्री',

  // visitor detail
  vd_title: 'विज़िट का विवरण',
  vd_type_guest: 'मेहमान',
  vd_type_delivery: 'डिलीवरी',
  vd_type_cab: 'कैब',
  vd_type_staff: 'स्टाफ़ विज़िट',
  vd_view_photo: 'फोटो देखें',
  vd_no_photo: 'अभी कोई फोटो नहीं',
  vd_err_title: 'विज़िट नहीं मिली',
  vd_err_body: 'यह एंट्री हटाई जा चुकी हो सकती है, या आपके पास इसका एक्सेस नहीं है।',
  vd_back: 'विज़िटर पर वापस',
  vd_call: 'कॉल करें',
  vd_call_a11y: '{name} को कॉल करें',
  vd_expected_from: 'आने का समय',
  vd_expected_until: 'इस समय तक',
  vd_arrived: 'गेट पर पहुँचे',
  vd_checked_in: 'अंदर आए',
  vd_checked_out: 'बाहर गए',
  vd_no_timings: 'इस विज़िट का कोई गेट समय दर्ज नहीं।',
  vd_company: 'कंपनी',
  vd_vehicle: 'गाड़ी',
  vd_id_checked: 'ID देखी गई',
  vd_approved_by: 'किसने मंज़ूरी दी',
  vd_no_details: 'गेट पर कोई अतिरिक्त जानकारी दर्ज नहीं हुई।',
  vd_notes: 'नोट',
  vd_captured: 'गार्ड ने एंट्री पर ली।',

  // community issue categories
  ic_cleanliness: 'सफ़ाई',
  ic_lift: 'लिफ्ट',
  ic_noise: 'शोर',
  ic_water: 'पानी',
  ic_parking: 'पार्किंग',
  ic_electrical: 'बिजली',
  ic_garbage: 'कचरा',
  ic_plumbing: 'प्लंबिंग',
  ic_housekeeping: 'हाउसकीपिंग',
  ic_internet: 'इंटरनेट',
  ic_security: 'सुरक्षा',
  ic_maintenance: 'मेंटेनेंस',
  ic_general: 'सामान्य',
  ic_other: 'अन्य',

  // discussion tags
  dt_general: 'सामान्य',
  dt_lost_found: 'खोया-पाया',
  dt_recommendations: 'सुझाव',
  dt_help: 'मदद',
  dt_events: 'इवेंट',
  dt_announcements: 'घोषणाएँ',
  dt_activities: 'गतिविधियाँ',

  // celebration kind
  ck_birthday: 'जन्मदिन',
  ck_anniversary: 'सालगिरह',

  // notification category
  nc_visitor: 'विज़िटर',
  nc_security: 'सुरक्षा',
  nc_notice: 'सूचना',
  nc_payment: 'पेमेंट',
  nc_booking: 'बुकिंग',
  nc_event: 'इवेंट',
  nc_poll: 'पोल',
  nc_community: 'कम्युनिटी',
  nc_system: 'सिस्टम',
  nc_helpdesk: 'हेल्पडेस्क',
  nc_maintenance: 'मेंटेनेंस',

  // date grid weekday letters
  wd_s0: 'र', wd_m: 'सो', wd_t2: 'मं', wd_w: 'बु', wd_t4: 'गु', wd_f: 'शु', wd_s6: 'श',

  // outbound share text
  gp_share_text_link: '{name} के लिए Bero गेट पास। गेट पर यह दिखाएँ:\n{link}',
  gp_share_text_code: '{name} के लिए Bero गेट पास — कोड {code}। {valid}।',
  gp_share_title: 'Bero गेट पास',
  pi_share_text: 'आपको न्योता है — {title}! अपने गेट पास के लिए टैप करें:\n{link}',

  // Gate tab (hub)
  gt_at_gate_now: 'गेट पर अभी',
  gt_none_waiting: 'गेट पर कोई प्रतीक्षा नहीं कर रहा',
  gt_none_waiting_sub: 'किसी के आते ही आपको सूचित किया जाएगा।',
  gt_tap_review: 'देखने के लिए टैप करें',
  gt_preapprove: 'विज़िटर को पूर्व-स्वीकृति दें',
  gt_gate_security: 'गेट और सुरक्षा',
  gt_svc_gatepass: 'गेट पास',
  gt_svc_gatepass_sub: 'QR / PIN शेयर करें',
  gt_svc_party: 'पार्टी न्योता',
  gt_svc_party_sub: 'एक लिंक, कई मेहमान',
  gt_svc_message: 'गेट को संदेश',
  gt_svc_message_sub: 'गार्ड डेस्क को नोट',
  gt_svc_history: 'विज़िटर इतिहास',
  gt_svc_history_sub: 'कौन आया-गया',
  gt_svc_staff: 'घरेलू स्टाफ़',
  gt_svc_staff_sub: 'मेड, कुक, ड्राइवर',
  gt_svc_attendance: 'हाज़िरी',
  gt_svc_attendance_sub: 'स्टाफ़ अंदर / बाहर',
  gt_svc_parcels: 'पार्सल',
  gt_svc_parcels_sub: 'गेट पर रखे',
  gt_svc_delivery_pin: 'डिलीवरी PIN',
  gt_svc_delivery_pin_sub: 'ड्रॉप ऑटो-स्वीकृत',
  gt_svc_family: 'फैमिली पास',
  gt_svc_family_sub: 'स्थायी प्रवेश',
  gt_svc_kids: 'बच्चे',
  gt_svc_kids_sub: 'नियमित अनुमतियाँ',
  gt_svc_move: 'मूव इन / आउट',
  gt_svc_move_sub: 'स्लॉट का अनुरोध',

  // Onboarding — shared steps rail
  onb_step_society: 'अपनी सोसाइटी ढूँढें',
  onb_step_society_sub: 'नाम या शहर से खोजें',
  onb_step_society_chosen: 'सोसाइटी चुनी गई',
  onb_step_flat: 'अपना फ्लैट चुनें',
  onb_step_flat_sub: 'विंग और नंबर',
  onb_step_flat_chosen: 'फ्लैट चुना गया',
  onb_step_verify: 'निवास सत्यापित करें',
  onb_step_verify_sub: 'भूमिका और एक दस्तावेज़',
  onb_step_account: 'अपना खाता बनाएँ',
  onb_step_account_sub: 'नाम, ईमेल और पासवर्ड',

  // Onboarding — shared bits
  onb_back: 'वापस',
  onb_done: 'हो गया',
  onb_choose_society: 'सोसाइटी चुनें',
  onb_start_over_title: 'फिर से शुरू करें',
  onb_check_connection: 'अपना कनेक्शन जाँचें और फिर कोशिश करें।',
  onb_your_society: 'आपकी सोसाइटी',
  onb_sign_out: 'साइन आउट',
  onb_foot_note: 'आपकी सोसाइटी कमेटी द्वारा समीक्षा की जाती है। Bero न विज्ञापन दिखाता है, न डेटा बेचता है।',

  // Onboarding — society select
  onb_soc_title: 'आप किस सोसाइटी में रहते हैं?',
  onb_soc_sub_desktop: 'हम उसी समुदाय के लिए आपका खाता सेट करेंगे।',
  onb_soc_sub_mobile: 'चरण 1/3 · हम उसी समुदाय के लिए आपका खाता सेट करेंगे।',
  onb_soc_search_ph: 'सोसाइटी का नाम या शहर से खोजें',
  onb_results: 'परिणाम',
  onb_near_you: 'आपके पास',
  onb_soc_cant_find: 'अपनी सोसाइटी नहीं मिल रही?',
  onb_soc_ask_bring: 'हमें वहाँ Bero लाने के लिए कहें',
  onb_soc_not_on_bero: 'अभी BERO पर नहीं',
  onb_soc_flats: '{count} फ्लैट',
  onb_soc_err_title: 'सोसाइटी लोड नहीं हो सकीं',
  onb_soc_none_title: 'कोई सोसाइटी नहीं मिली',
  onb_soc_none_body: 'कोई दूसरा नाम आज़माएँ या स्पेलिंग जाँचें।',

  // Onboarding — lead capture
  onb_lead_done_title: 'मिल गया — हम इस पर काम कर रहे हैं',
  onb_lead_done_body: 'हम {society} में Bero लाने के बारे में आपसे संपर्क करेंगे। कोई स्पैम नहीं — बस एक कॉल।',
  onb_lead_your_society: 'आपकी सोसाइटी',
  onb_lead_title: 'अपनी सोसाइटी में Bero लाएँ',
  onb_lead_sub: 'बताएँ आप कहाँ रहते हैं और हम आपकी कमेटी से बात करेंगे।',
  onb_lead_society_label: 'सोसाइटी का नाम',
  onb_lead_society_ph: 'जैसे Palm Meadows CHS',
  onb_lead_city_label: 'शहर',
  onb_lead_city_ph: 'जैसे पुणे',
  onb_lead_name_label: 'आपका नाम (वैकल्पिक)',
  onb_lead_name_ph: 'ताकि हमें पता हो किससे पूछना है',
  onb_lead_phone_label: 'फ़ोन',
  onb_lead_error: 'अभी यह भेज नहीं सके। थोड़ी देर में फिर कोशिश करें।',
  onb_lead_submit: 'Bero का अनुरोध करें',

  // Onboarding — flat select
  onb_flat_no_soc_title: 'पहले सोसाइटी चुनें',
  onb_flat_no_soc_body: 'जारी रखने के लिए वापस जाएँ और अपनी सोसाइटी चुनें।',
  onb_wing_n: 'विंग {code}',
  onb_flat_title: 'आपका फ्लैट कौन-सा है?',
  onb_flat_claimed_locked: 'लिए जा चुके फ्लैट लॉक हैं',
  onb_flat_sub_mobile: 'चरण 2/3 · लिए जा चुके फ्लैट लॉक हैं',
  onb_flat_err_title: 'फ्लैट लोड नहीं हो सके',
  onb_flat_none_title: 'कोई फ्लैट नहीं मिला',
  onb_flat_none_body: 'इस विंग में अभी कोई फ्लैट सूचीबद्ध नहीं है।',
  onb_flat_continue_with: '{code} के साथ जारी रखें',
  onb_flat_select_cta: 'जारी रखने के लिए फ्लैट चुनें',

  // Onboarding — verify residency
  onb_role_owner: 'मालिक',
  onb_role_owner_sub: 'फ्लैट मेरे नाम पर पंजीकृत है',
  onb_role_tenant: 'किरायेदार',
  onb_role_tenant_sub: 'मैं यह फ्लैट किराए पर लेता/लेती हूँ',
  onb_role_family: 'परिवार का सदस्य',
  onb_role_family_sub: 'मैं मालिक या किरायेदार के साथ रहता/रहती हूँ',
  onb_verify_title: 'सत्यापित करें कि आप यहाँ रहते हैं',
  onb_verify_reviewed: 'आपकी कमेटी द्वारा समीक्षित',
  onb_verify_sub_mobile: 'चरण 3/3 · आपकी कमेटी द्वारा समीक्षित',
  onb_verify_i_am: 'मैं हूँ',
  onb_verify_proof: 'निवास का प्रमाण',
  onb_verify_upload_title: 'एग्रीमेंट या बिजली बिल अपलोड करें',
  onb_verify_upload_hint: 'PDF या फोटो · अधिकतम 10 MB',
  onb_verify_upload_unavailable: 'दस्तावेज़ अपलोड अभी उपलब्ध नहीं है।',
  onb_verify_encrypt_note: 'आपके दस्तावेज़ एन्क्रिप्टेड हैं और केवल आपकी सोसाइटी एडमिन के साथ साझा किए जाते हैं। किसी तीसरे पक्ष के साथ कभी नहीं।',
  onb_verify_start_over_body: 'जारी रखने के लिए अपनी सोसाइटी और फ्लैट फिर से चुनें।',
  onb_verify_submit: 'स्वीकृति के लिए भेजें',

  // Onboarding — create account
  onb_signup_title: 'अपना खाता बनाएँ',
  onb_signup_sub: 'आख़िरी चरण — इसी से आप साइन इन करेंगे।',
  onb_signup_start_over_body: 'अपना खाता बनाने के लिए अपनी सोसाइटी फिर से चुनें।',
  onb_signup_flat: 'फ्लैट {code}',
  onb_signup_name_label: 'पूरा नाम',
  onb_signup_name_ph: 'जैसे अमित शर्मा',
  onb_signup_email_label: 'ईमेल पता',
  onb_signup_phone_label: 'फ़ोन नंबर',
  onb_signup_phone_help: 'गेट पर आप तक पहुँचने के लिए इसका उपयोग करेंगे।',
  onb_signup_password_label: 'पासवर्ड',
  onb_signup_min8: 'कम से कम 8 अक्षर।',
  onb_signup_err_name: 'अपना पूरा नाम दर्ज करें।',
  onb_signup_err_email: 'एक मान्य ईमेल पता दर्ज करें।',
  onb_signup_err_phone: 'एक मान्य फ़ोन नंबर दर्ज करें।',
  onb_signup_err_email_taken: 'यह ईमेल पहले से पंजीकृत है।',
  onb_signup_err_society_404: 'यह सोसाइटी नहीं मिली। कृपया फिर से शुरू करें।',
  onb_signup_err_generic: 'अभी आपका खाता नहीं बना सके। थोड़ी देर में फिर कोशिश करें।',
  onb_signup_submit: 'खाता बनाएँ',

  // Onboarding — pending approval
  onb_pending_title: 'गेट पर प्रतीक्षा में',
  onb_pending_body: 'आपकी कमेटी नए निवासियों की समीक्षा करती है। ज़्यादातर स्वीकृतियाँ एक दिन में हो जाती हैं। जैसे ही आप शामिल होंगे, हम आपको ईमेल कर देंगे।',
  onb_pending_badge: 'लंबित',
  onb_pending_submitted: '{when} को भेजा गया',
  onb_pending_notify: 'स्वीकृति मिलने पर सूचित करें',

  // polls (index)
  poll_active: 'चालू',
  poll_err_body: 'पोल लोड करने में कुछ गड़बड़ हो गई। अपना इंटरनेट देखकर फिर से कोशिश करें।',
  poll_empty_closed_title: 'कोई बंद पोल नहीं',
  poll_empty_closed_body: 'किसी पोल के बंद होने पर नतीजे यहाँ दिखेंगे।',
  poll_vote_error: 'आपका वोट दर्ज नहीं हो सका। कृपया फिर से कोशिश करें।',
  poll_submit_vote: 'वोट भेजें',

  // events (index)
  event_err_body: 'इवेंट लोड करने में कुछ गड़बड़ हो गई। अपना इंटरनेट देखकर फिर से कोशिश करें।',
  event_empty_upcoming_title: 'कोई आने वाला इवेंट नहीं',
  event_empty_upcoming_body: 'जब कमेटी कोई इवेंट तय करेगी, वह यहाँ दिखेगा।',
  event_empty_past_title: 'कोई पिछला इवेंट नहीं',
  event_empty_past_body: 'इवेंट होने के बाद यहाँ आ जाते हैं।',
  event_create: 'इवेंट बनाएँ',
  event_going: '{n} जा रहे हैं',

  // issues (index)
  issue_tab_personal: 'निजी',
  issue_err_body: 'शिकायतें लोड करने में कुछ गड़बड़ हो गई। अपना इंटरनेट देखकर फिर से कोशिश करें।',
  issue_empty_personal_title: 'कोई निजी शिकायत नहीं',
  issue_empty_personal_body: 'अपने फ्लैट के लिए दर्ज की गई शिकायतें यहाँ दिखेंगी।',
  issue_upvote_error: 'आपका अपवोट दर्ज नहीं हो सका। कृपया फिर से कोशिश करें।',
  issue_report: 'शिकायत दर्ज करें',
  issue_notify_wing: 'विंग के निवासियों को सूचित किया',
  issue_notify_all: 'सभी निवासियों को सूचित किया',
  issue_notify_helpdesk: 'हेल्पडेस्क को सूचित किया',
  issue_notify_wing_x: 'विंग {wing} के निवासियों को सूचित किया',
  ev_cat_festival: 'त्योहार',
  ev_cat_sports: 'खेल',
  ev_cat_kids: 'बच्चे',
  ev_cat_cultural: 'सांस्कृतिक',
  ev_cat_meeting: 'मीटिंग',
  ev_cat_general: 'सामान्य',

  // vendors (index)
  vendor_title: 'भरोसेमंद वेंडर',
  vendor_cat_electrician: 'इलेक्ट्रीशियन',
  vendor_cat_housekeeping: 'हाउसकीपिंग',
  vendor_cat_appliance: 'उपकरण',
  vendor_cat_gardening: 'बागवानी',
  vendor_cat_plumbing: 'प्लंबिंग',
  vendor_cat_carpentry: 'बढ़ईगीरी',
  vendor_cat_painting: 'पेंटिंग',
  vendor_cat_pest: 'कीट नियंत्रण',
  vendor_err_title: 'वेंडर लोड नहीं हो सके',
  vendor_err_body: 'वेंडर लोड करने में कुछ गड़बड़ हो गई। अपना इंटरनेट देखकर फिर से कोशिश करें।',
  vendor_empty_title: 'यहाँ कोई वेंडर नहीं',
  vendor_empty_body: 'इस श्रेणी में निवासियों द्वारा सुझाए गए वेंडर यहाँ दिखेंगे।',
  vendor_pinned: 'पिन किया',
  vendor_endorsement: '{n} निवासी सिफ़ारिश',
  vendor_endorsements: '{n} निवासी सिफ़ारिशें',
  vendor_call: '{name} को कॉल करें',

  // visitors (index)
  vis_title: 'विज़िटर',
  vis_filter: 'फ़िल्टर',
  vis_err_title: 'विज़िटर इतिहास उपलब्ध नहीं',
  vis_err_body: 'हम अभी गेट रिकॉर्ड तक नहीं पहुँच सके। थोड़ी देर बाद देखें।',
  vis_empty_title: 'अभी कोई विज़िटर नहीं',
  vis_empty_body: 'अप्रूव, रिजेक्ट और पहले से मंज़ूर विज़िटर यहाँ दिखेंगे।',
  vis_preapprove: 'विज़िटर को पहले से मंज़ूरी दें',
  vis_group_earlier: 'इससे पहले',
  vis_load_earlier: 'पुराने विज़िटर लोड करें',

  // poll (detail)
  poll_detail_title: 'पोल',
  poll_unavailable_title: 'पोल उपलब्ध नहीं',
  poll_unavailable_body: 'यह पोल हटाया जा चुका हो सकता है, या लोड करते समय कुछ गड़बड़ हुई।',
  poll_posted_by: '{name} द्वारा पोस्ट किया',
  poll_total_votes: 'कुल {n} वोट',
  poll_anon_note: 'जवाब गुमनाम हैं',

  // event (detail)
  event_detail_title: 'इवेंट',
  event_unavailable_title: 'इवेंट उपलब्ध नहीं',
  event_unavailable_body: 'यह इवेंट हटाया जा चुका हो सकता है, या लोड करते समय कुछ गड़बड़ हुई।',
  event_going_residents: '{n} निवासी जा रहे हैं',
  event_whos_going: 'कौन जा रहा है',
  event_more: '+{n} और',
  event_rsvp_going: 'जा रहे हैं',
  event_rsvp_maybe: 'शायद',
  event_rsvp_cant: 'नहीं जा सकते',
  event_rsvp_error: 'आपका RSVP सेव नहीं हो सका। कृपया फिर से कोशिश करें।',

  // issue (detail)
  issue_detail_title: 'शिकायत',
  issue_unavailable_title: 'शिकायत उपलब्ध नहीं',
  issue_comment_error: 'आपका कमेंट पोस्ट नहीं हो सका। कृपया फिर से कोशिश करें।',
  issue_status_reported: 'दर्ज की गई',
  issue_status_progress: 'प्रगति पर',
  issue_status_urgent: 'ज़रूरी',
  issue_status_resolved: 'हल हो गई',

  // notice (detail)
  notice_detail_title: 'सूचना',
  notice_unavailable_title: 'सूचना उपलब्ध नहीं',
  notice_unavailable_body: 'यह सूचना हटाई जा चुकी हो सकती है, या लोड करते समय कुछ गड़बड़ हुई।',
  notice_read_by_one: '{n} निवासी ने पढ़ा',
  notice_read_by_many: '{n} निवासियों ने पढ़ा',
  notice_attachments: 'अटैचमेंट',
  notice_open: 'खोलें',
  notice_ack_error: 'यह दर्ज नहीं हो सका। कृपया फिर से कोशिश करें।',

  // vendor (detail)
  vendor_detail_title: 'वेंडर',
  vendor_unavailable_title: 'वेंडर उपलब्ध नहीं',
  vendor_unavailable_body: 'यह वेंडर हटाया जा चुका हो सकता है, या लोड करते समय कुछ गड़बड़ हुई।',
  vendor_endorsements_count: '{n} सिफ़ारिशें',
  vendor_endorsed: 'सिफ़ारिश की',
  vendor_endorse: 'सिफ़ारिश करें',
  vendor_resident_notes: 'निवासियों के नोट्स',
  vendor_endorse_error: 'आपकी सिफ़ारिश अपडेट नहीं हो सकी। कृपया फिर से कोशिश करें।',

  // issues/report (create form)
  ir_title: 'समस्या दर्ज करें',
  ir_discard: 'रद्द करें',
  ir_title_ph: 'जैसे बेसमेंट में पाइप लीक हो रहा है',
  ir_visibility: 'दृश्यता',
  ir_vis_personal: 'व्यक्तिगत',
  ir_vis_community: 'समुदाय',
  ir_vis_help_community: 'दूसरे निवासी इसे देख और अपवोट कर सकते हैं।',
  ir_vis_help_personal: 'इसे सिर्फ़ आप और हेल्पडेस्क देख सकते हैं।',
  ir_notify: 'सूचित करें',
  ir_notify_wing: 'मेरा विंग',
  ir_notify_all: 'सभी निवासी',
  ir_notify_helpdesk: 'हेल्पडेस्क',
  ir_desc_ph: 'क्या ख़राबी है, और कहाँ?',
  ir_submit_error: 'अभी समस्या दर्ज नहीं हो सकी। थोड़ी देर में फिर कोशिश करें।',
  ir_submit: 'समस्या दर्ज करें',

  // events/create (create form)
  ec_title: 'कार्यक्रम बनाएँ',
  ec_discard: 'रद्द करें',
  ec_add_cover: 'कवर इमेज जोड़ें',
  ec_title_label: 'कार्यक्रम का नाम',
  ec_title_ph: 'जैसे दिवाली उत्सव',
  ec_date: 'तारीख़',
  ec_date_ph: '9 नवंबर 2026',
  ec_time: 'समय',
  ec_time_ph: '7:00 PM',
  ec_venue: 'स्थान',
  ec_venue_ph: 'क्लबहाउस लॉन',
  ec_desc_ph: 'क्या हो रहा है?',
  ec_submit_error: 'अभी कार्यक्रम दर्ज नहीं हो सका। थोड़ी देर में फिर कोशिश करें।',
  ec_submit: 'कार्यक्रम दर्ज करें',

  // staff (directory + register)
  staff_title: 'मेरा स्टाफ़ और मदद',
  staff_register_new: 'नया स्टाफ़ पंजीकृत करें',
  staff_info_note: 'पंजीकृत मदद अपने निजी कोड से अंदर आ सकती है। आप आने-जाने का समय देख पाएँगे।',
  staff_error_title: 'स्टाफ़ सूची उपलब्ध नहीं',
  staff_error_body: 'अभी आपका स्टाफ़ लोड नहीं हो सका। थोड़ी देर में फिर कोशिश करें।',
  staff_section_mine: 'मेरा स्टाफ़',
  staff_empty_mine: 'अभी आपके फ़्लैट से कोई स्टाफ़ नहीं जुड़ा है। नीचे से जोड़ें, या + से किसी नए को पंजीकृत करें।',
  staff_section_directory: 'इस सोसायटी में काम करते हैं',
  staff_directory_hint: 'पड़ोसियों ने पहले ही पंजीकृत किया है — एक टैप में अपने फ़्लैट से जोड़ें।',
  staff_view_attendance: 'हाज़िरी लॉग देखें',
  staff_add: 'जोड़ें',
  staff_adding: 'जोड़ा जा रहा है…',
  staff_add_error: '{name} को जोड़ा नहीं जा सका। थोड़ी देर में फिर कोशिश करें।',
  staff_register_error: 'अभी इन्हें पंजीकृत नहीं किया जा सका। थोड़ी देर में फिर कोशिश करें।',
  staff_sheet_title: 'घरेलू मदद पंजीकृत करें',
  staff_field_name: 'नाम',
  staff_name_ph: 'जैसे सुनीता बाई',
  staff_field_role: 'भूमिका',
  staff_field_phone: 'फ़ोन (वैकल्पिक)',
  staff_field_schedule: 'समय-सारणी (वैकल्पिक)',
  staff_schedule_ph: 'सोम–शनि · सुबह 9–11',
  staff_sheet_note: 'इन्हें एक निजी गेट कोड मिलता है — गार्ड इससे इनके आने-जाने का समय दर्ज करते हैं।',
  staff_register: 'पंजीकृत करें',
  staff_role_maid: 'मेड',
  staff_role_cook: 'रसोइया',
  staff_role_driver: 'ड्राइवर',
  staff_role_nanny: 'आया',
  staff_role_presswala: 'प्रेसवाला',
  staff_presence_inside: 'अंदर',
  staff_presence_left: 'निकल गए',
  staff_presence_not_in: 'नहीं आए',

  // staff ID card (detail)
  sid_title: 'स्टाफ़ आईडी कार्ड',
  sid_more_options: 'और विकल्प',
  sid_error_title: 'स्टाफ़ विवरण उपलब्ध नहीं',
  sid_notfound_title: 'स्टाफ़ सदस्य नहीं मिला',
  sid_error_body: 'अभी यह आईडी कार्ड लोड नहीं हो सका।',
  sid_badge: 'स्टाफ़ आईडी',
  sid_id_verified: 'आईडी सत्यापित',
  sid_verification_pending: 'सत्यापन बाकी',
  sid_works_for: 'किसके लिए काम',
  sid_gate_code: 'गेट कोड',
  sid_this_month: 'इस महीने',
  sid_days_in_one: '{n} दिन उपस्थित',
  sid_days_in_many: '{n} दिन उपस्थित',
  sid_updating: 'अपडेट हो रहा है…',
  sid_change_photo: 'फ़ोटो बदलें',
  sid_add_photo: 'फ़ोटो जोड़ें',
  sid_photo_error: 'फ़ोटो अपडेट नहीं हो सकी। थोड़ी देर में फिर कोशिश करें।',
  sid_no_ratings: 'अभी कोई रेटिंग नहीं',
  sid_rating_summary_one: '{avg} · {n} रेटिंग',
  sid_rating_summary_many: '{avg} · {n} रेटिंग',
  sid_you_rated_one: 'आपने {n} स्टार दिया — बदलने के लिए टैप करें',
  sid_you_rated_many: 'आपने {n} स्टार दिए — बदलने के लिए टैप करें',
  sid_rate_prompt: 'अपने फ़्लैट के लिए इनके काम को रेट करें',
  sid_record_payment: 'भुगतान दर्ज करें',
  sid_record_payment_sub: 'अपने फ़्लैट के लिए निजी वेतन लॉग रखें',
  sid_attendance_summary: 'हाज़िरी सारांश',
  sid_attendance_summary_sub: 'इस सदस्य का आने-जाने का लॉग',
  sid_removing: 'हटाया जा रहा है…',
  sid_remove_from_flat: 'मेरे फ़्लैट से हटाएँ',
  sid_remove_note: 'ये सोसायटी में पंजीकृत रहते हैं — इससे सिर्फ़ आपके फ़्लैट से जुड़ाव हटता है।',
  sid_remove_error: 'इन्हें आपके फ़्लैट से हटाया नहीं जा सका। थोड़ी देर में फिर कोशिश करें।',
  sid_rate_title: '{name} का काम कैसा है?',
  sid_rate_note_label: 'कुछ जोड़ना है? (वैकल्पिक)',
  sid_rate_note_ph: 'इसे सिर्फ़ आपका सोसायटी एडमिन देख सकता है',
  sid_save_rating: 'रेटिंग सहेजें',
  sid_pay_title: 'भुगतान दर्ज करें',
  sid_amount_label: 'राशि (₹)',
  sid_note_label: 'नोट (वैकल्पिक)',
  sid_pay_note_ph: 'जुलाई का वेतन, दिवाली बोनस…',
  sid_record: 'दर्ज करें',
  sid_recent: 'हाल के',
  sid_entry_remove_error: 'वह प्रविष्टि हटाई नहीं जा सकी। थोड़ी देर में फिर कोशिश करें।',
  sid_pay_error: 'भुगतान दर्ज नहीं हो सका। थोड़ी देर में फिर कोशिश करें।',
  sid_rating_error: 'रेटिंग सहेजी नहीं जा सकी। थोड़ी देर में फिर कोशिश करें।',
  sid_pay_note_footer: 'आपके फ़्लैट तक निजी — एक निजी बही-खाता, कोई ट्रांसफ़र नहीं।',

  // forgot-password (fgp_*)
  fgp_title: 'अपना पासवर्ड रीसेट करें',
  fgp_subtitle: 'हम आपको रीसेट लिंक ईमेल करेंगे। मैजिक-लिंक साइन-इन के लिए कभी पासवर्ड की ज़रूरत नहीं होती।',
  fgp_send: 'रीसेट लिंक ईमेल करें',
  fgp_back_to_signin: 'साइन-इन पर वापस जाएँ',
  fgp_check_title: 'अपना ईमेल देखें',
  fgp_check_body: 'अगर {email} के लिए कोई खाता मौजूद है, तो आपको जल्द ही एक रीसेट लिंक मिलेगा।',

  // reset-password (rp_*)
  rp_title: 'नया पासवर्ड सेट करें',
  rp_for: '{who} के लिए',
  rp_your_account: 'आपके खाते',
  rp_new_password_label: 'नया पासवर्ड',
  rp_confirm_label: 'पासवर्ड की पुष्टि करें',
  rp_min: 'कम से कम 8 अक्षर, जिनमें एक अंक हो।',
  rp_mismatch: 'पासवर्ड मेल नहीं खाते।',
  rp_save: 'नया पासवर्ड सहेजें',
  rp_strength_weak: 'कमज़ोर',
  rp_strength_good: 'अच्छा',
  rp_strength_strong: 'मज़बूत',
  rp_done_title: 'पासवर्ड रीसेट हो गया',
  rp_done_body: 'कृपया अपने नए पासवर्ड से साइन इन करें।',

  // magic-sent (ms_*)
  ms_title: 'अपना मेल देखें',
  ms_body_before: 'हमने इस पते पर साइन-इन लिंक भेजा है —',
  ms_body_after: '। इसी डिवाइस पर ईमेल खोलें और जारी रखने के लिए लिंक पर टैप करें।',
  ms_your_email: 'आपके ईमेल पते',
  ms_open_mail: 'मेल ऐप खोलें',
  ms_resend_countdown: 'नहीं मिला? दोबारा भेजें ({secs} सेकंड)',
  ms_resend: 'लिंक दोबारा भेजें',

  // login continue
  login_continue: 'आगे बढ़ें',
  // verify-code (vc_*)
  vc_title: 'अपना कोड डालें',
  vc_sent_to: 'हमने {email} पर 6-अंकों का कोड भेजा है। साइन इन करने के लिए उसे नीचे डालें।',
  vc_code_label: '6-अंकों का कोड',
  vc_verify: 'सत्यापित करें',
  vc_resend: 'कोड दोबारा भेजें',
  vc_resend_in: '{s} सेकंड में दोबारा भेजें',
  vc_err_invalid: 'यह कोड ग़लत है या इसकी समय-सीमा समाप्त हो चुकी है।',
  vc_err_rate: 'बहुत अधिक कोशिशें। कृपया थोड़ी देर रुककर दोबारा प्रयास करें।',
  vc_err_generic: 'कुछ गड़बड़ हो गई। कृपया दोबारा प्रयास करें।',

  // pay/success (ps_*)
  ps_paid_thanks: 'भुगतान हो गया, धन्यवाद',
  ps_received: 'भुगतान मिल गया',
  ps_paid_via: 'इसके ज़रिए भुगतान',
  ps_reference: 'संदर्भ',
  ps_time: 'समय',
  ps_receipt: 'रसीद',
  ps_download_pdf: 'PDF डाउनलोड करें',
  ps_done: 'पूरा हुआ',

  // +not-found (nf_*)
  nf_title: 'यह गेट कहीं नहीं जाता',
  nf_body: 'आप जो पेज ढूँढ रहे हैं वह मौजूद नहीं है, या हटा दिया गया होगा।',

  // CompanyPicker (cp_*)
  cp_more: 'और…',
  cp_which_cab: 'कौन-सी कैब सेवा?',
  cp_which_company: 'कौन-सी कंपनी?',
  cp_search_ph: 'कंपनियाँ खोजें',
  cp_use: '“{q}” इस्तेमाल करें',
  cp_no_companies: 'कोई कंपनी नहीं।',

  // meetings — shared/index (mtg_*)
  nav_new: 'नया',
  mtg_kind_mc: 'समिति',
  mtg_kind_agm: 'AGM',
  mtg_kind_sgm: 'SGM',
  mtg_status_draft: 'ड्राफ़्ट',
  mtg_status_noticed: 'सूचित',
  mtg_status_held: 'संपन्न',
  mtg_status_minutes_due: 'कार्यवृत्त बाकी',
  mtg_status_closed: 'बंद',
  mtg_status_cancelled: 'रद्द',
  mtg_title: 'बैठकें',
  mtg_forbidden_title: 'केवल समिति',
  mtg_forbidden_body: 'बैठकें समिति और पदाधिकारी चलाते हैं। यदि आपको पहुँच मिलनी चाहिए तो अपनी समिति से पूछें।',
  mtg_err_title: 'बैठकें लोड नहीं हो सकीं',
  mtg_agm_due: 'AGM {days} दिनों में देय — {date} तक',
  mtg_agm_overdue: 'AGM {days} दिन विलंबित',
  mtg_empty_title: 'अभी कोई बैठक नहीं',
  mtg_empty_cta: 'बैठक निर्धारित करें',
  mtg_quorum_count: 'कोरम {p}/{r}',
  mtg_not_met: 'पूरा नहीं',

  // meetings/new (mtn_*)
  mtn_title: 'बैठक निर्धारित करें',
  mtn_err_date: 'तारीख YYYY-MM-DD होनी चाहिए, जैसे 2026-07-28।',
  mtn_err_time: 'समय HH:MM (24घं) होना चाहिए, जैसे 18:30।',
  mtn_err_generic: 'बैठक निर्धारित नहीं हो सकी।',
  mtn_f_title: 'शीर्षक',
  mtn_f_title_help: 'डिफ़ॉल्ट: "{label}"',
  mtn_f_date: 'तारीख',
  mtn_f_time: 'समय (24घं)',
  mtn_f_venue: 'स्थान',
  mtn_ph_venue: 'सोसायटी कार्यालय',
  mtn_agenda: 'एजेंडा',
  mtn_ph_item: 'मद {n}',
  mtn_a11y_recusal: 'हित-टकराव के कारण अलग रहना टॉगल करें',
  mtn_recusal: 'अलग रहना',
  mtn_remove_item: 'मद हटाएँ',
  mtn_add_item: '+ मद जोड़ें',
  mtn_scheduling: 'निर्धारित हो रहा…',

  // meetings/[id] (mtd_*)
  mtd_title_meeting: 'बैठक',
  mtd_err_load: 'यह बैठक लोड नहीं हो सकी',
  mtd_notice: 'सूचना',
  mtd_business: 'कार्यसूची',
  mtd_recusal: 'अलग रहना',
  mtd_quorum: 'कोरम',
  mtd_required_present: 'आवश्यक: {n} उपस्थित',
  mtd_present_quorum: '{p}/{r} उपस्थित — कोरम {verdict}',
  mtd_met: 'पूरा',
  mtd_not_met: 'पूरा नहीं',
  mtd_certified_by: '{name} द्वारा प्रमाणित',
  mtd_the_committee: 'समिति',
  mtd_recorded_suffix: ' · {name} द्वारा दर्ज',
  mtd_minutes: 'कार्यवृत्त',
  mtd_not_recorded: 'अभी दर्ज नहीं।',
  mtd_working: 'हो रहा है…',
  mtd_issue_notice: 'सूचना जारी करें',
  mtd_ok_notice: 'सूचना जारी की गई और सदस्यों को सूचित किया गया।',
  mtd_mark_held: 'संपन्न के रूप में चिह्नित करें',
  mtd_record_minutes: 'कार्यवृत्त दर्ज करें',
  mtd_edit_minutes: 'कार्यवृत्त संपादित करें',
  mtd_certify_meeting: 'बैठक प्रमाणित करें',
  mtd_cancel_meeting: 'बैठक रद्द करें',
  mtd_ok_cancel: 'बैठक रद्द की गई।',
  mtd_done: 'हो गया।',
  mtd_err_generic: 'यह नहीं हो सका।',
  mtd_who_present: 'कौन उपस्थित था?',
  mtd_quorum_needs: 'कोरम के लिए {total} में से {q} समिति सदस्य आवश्यक।',
  mtd_members_present: 'उपस्थित सदस्य',
  mtd_quorum_help: 'कोरम: {n}',
  mtd_ph_headcount: 'जैसे 24',
  mtd_recording: 'दर्ज हो रहा…',
  mtd_record_attendance: 'उपस्थिति दर्ज करें',
  mtd_ok_attendance: 'उपस्थिति दर्ज — प्रमाणन के लिए दूसरे सदस्य की प्रतीक्षा।',
  mtd_minutes_of_meeting: 'बैठक का कार्यवृत्त',
  mtd_ph_minutes: 'लिए गए निर्णय, मत, देखी गई विरक्तियाँ…',
  mtd_saving: 'सहेज रहा…',
  mtd_save_minutes: 'कार्यवृत्त सहेजें',
  mtd_ok_minutes: 'कार्यवृत्त ड्राफ़्ट के रूप में सहेजा गया।',
  mtd_certify_the_meeting: 'बैठक प्रमाणित करें',
  mtd_cert_attendance: 'उपस्थिति व कोरम — {p}/{r} उपस्थित, कोरम {verdict}',
  mtd_cert_minutes: 'ऊपर दर्ज कार्यवृत्त',
  mtd_certifying: 'प्रमाणित हो रहा…',
  mtd_certify_full: 'उपस्थिति, कोरम व कार्यवृत्त प्रमाणित करें',
  mtd_ok_certified: 'बैठक प्रमाणित की गई।',

  // elections/index (el_*)
  el_phase_announced: 'घोषित',
  el_phase_nominations: 'नामांकन खुले',
  el_phase_scrutiny: 'जाँच',
  el_phase_voting: 'मतदान',
  el_phase_completed: 'पूर्ण',
  el_phase_cancelled: 'रद्द',
  el_title: 'चुनाव',
  el_err_title: 'चुनाव लोड नहीं हो सके',
  el_empty_title: 'अभी कोई चुनाव नहीं',
  el_intro: 'समिति चुनाव — हर सदस्य नामांकन, जाँच और परिणाम देख सकता है।',
  el_seat_one: '{n} सीट',
  el_seat_other: '{n} सीटें',
  el_term: 'कार्यकाल {t}',
  el_cand_one: '{n} उम्मीदवार',
  el_cand_other: '{n} उम्मीदवार',
  el_polls: 'मतदान {d}',

  // elections/new (eln_*)
  eln_title: 'चुनाव घोषित करें',
  eln_err_title: 'चुनाव को एक शीर्षक दें।',
  eln_err_seats: 'सीटें 1 से 50 के बीच संख्या होनी चाहिए।',
  eln_err_date: '{label} YYYY-MM-DD होनी चाहिए।',
  eln_err_generic: 'चुनाव घोषित नहीं हो सका।',
  eln_f_title: 'शीर्षक',
  eln_ph_title: 'प्रबंध समिति 2026–2031',
  eln_f_seats: 'सीटें',
  eln_ph_seats: 'जैसे 5',
  eln_f_term: 'कार्यकाल',
  eln_f_reserved: 'आरक्षित सीटें',
  eln_f_nomclose: 'नामांकन समाप्ति',
  eln_f_votedate: 'मतदान तिथि',
  eln_announcing: 'घोषित हो रहा…',

  // elections/[id] (eld_*)
  eld_adv_announced: 'नामांकन खोलें',
  eld_adv_nominations: 'नामांकन बंद करें — जाँच शुरू करें',
  eld_adv_scrutiny: 'मतदान खोलें',
  eld_title: 'चुनाव',
  eld_err_load: 'यह चुनाव लोड नहीं हो सका',
  eld_seat_one: '{n} सीट',
  eld_seat_other: '{n} सीटें',
  eld_term: 'कार्यकाल {t}',
  eld_nom_close: 'नामांकन समाप्ति {d}',
  eld_polls: 'मतदान {d}',
  eld_stand: 'चुनाव लड़ें',
  eld_nom_in: 'आपका नामांकन दर्ज हो गया — आगे जाँच होगी।',
  eld_ballot_in: 'आपका मत दर्ज हो गया। परिणाम घोषित होने पर दिखेंगे।',
  eld_results: 'परिणाम',
  eld_candidates: 'उम्मीदवार · {n}',
  eld_no_noms: 'अभी कोई नामांकन नहीं।',
  eld_member: 'सदस्य',
  eld_proposed_by: '{name} द्वारा प्रस्तावित',
  eld_pill_elected: 'निर्वाचित',
  eld_pill_rejected: 'अस्वीकृत',
  eld_pill_on_ballot: 'मतपत्र पर',
  eld_pill_pending: 'लंबित',
  eld_vote_one: '{n} वोट',
  eld_vote_other: '{n} वोट',
  eld_flagged: 'चिह्नित: {note}',
  eld_accept: 'स्वीकारें',
  eld_ok_accepted: '{name} मतपत्र पर हैं।',
  eld_reject: 'अस्वीकारें',
  eld_ok_rejected: '{name} जाँच में अस्वीकृत।',
  eld_vote_for: '{name} को वोट दें',
  eld_working: 'हो रहा है…',
  eld_ok_advanced: 'चरण आगे बढ़ा।',
  eld_declare: 'परिणाम घोषित करें',
  eld_ok_declared: 'परिणाम घोषित।',
  eld_constitute: 'समिति का गठन करें',
  eld_ok_constituted: 'विजेता समिति सदस्य पद पर जोड़े गए।',
  eld_cancel_election: 'चुनाव रद्द करें',
  eld_ok_cancelled: 'चुनाव रद्द किया गया।',
  eld_f_statement: 'वक्तव्य',
  eld_f_statement_help: 'वैकल्पिक — सदस्य आपको वोट क्यों दें',
  eld_ph_statement: 'सोसायटी के लिए आप किस पर ध्यान देंगे',
  eld_submitting: 'सबमिट हो रहा…',
  eld_submit_nom: 'नामांकन सबमिट करें',
  eld_ok_nom: 'नामांकन सबमिट किया गया।',
  eld_cast_ballot: 'अपना मत डालें',
  eld_vote_confirm: '{name} को वोट दें?',
  eld_ballot_rules: 'प्रति सदस्य एक ही मत; इसे बदला नहीं जा सकता। परिणाम घोषित होने तक गिनती सील रहती है।',
  eld_casting: 'डाला जा रहा…',
  eld_cast_btn: 'मत डालें',
  eld_ok_ballot: 'मत डाला गया।',
  eld_recording: 'दर्ज हो रहा…',
  eld_record_result: 'परिणाम दर्ज करें',
  eld_ok_recorded: 'परिणाम दर्ज किए गए।',
  eld_err_generic: 'यह नहीं हो सका।',

  // finances (fin_*)
  fin_cat_maintenance: 'रखरखाव',
  fin_cat_repairs: 'मरम्मत',
  fin_cat_security: 'सुरक्षा',
  fin_cat_utilities: 'उपयोगिताएँ',
  fin_cat_housekeeping: 'साफ़-सफ़ाई',
  fin_cat_events: 'कार्यक्रम',
  fin_cat_admin: 'प्रशासन',
  fin_cat_other: 'अन्य',
  fin_err_amount: 'राशि रुपयों में दर्ज करें।',
  fin_err_note: 'बताएँ कि खर्च किसलिए था।',
  fin_err_date: 'तारीख YYYY-MM-DD होनी चाहिए।',
  fin_ok_recorded: '{amount} {cat} के अंतर्गत दर्ज।',
  fin_err_record: 'खर्च दर्ज नहीं हो सका।',
  fin_ok_voided: '{amount} की प्रविष्टि रद्द — ऑडिट ट्रेल पर दर्ज।',
  fin_err_void: 'रद्द नहीं हो सका।',
  fin_err_receipt: 'रसीद नहीं खुल सकी।',
  fin_title: 'सोसायटी वित्त',
  fin_expense_btn: 'खर्च',
  fin_err_load: 'वित्त लोड नहीं हो सका',
  fin_intro: 'सोसायटी में आने-जाने वाला हर रुपया, महीने-दर-महीने। रसीदें कोषाध्यक्ष दर्ज करते हैं; खर्च रसीदों के साथ ऑडिट ट्रेल पर आते हैं।',
  fin_monthly_statement: 'मासिक विवरण',
  fin_collected: 'एकत्रित',
  fin_spent: 'खर्च',
  fin_ledger_title: 'खर्च बही · समिति दृश्य',
  fin_no_expenses: 'अभी कोई खर्च दर्ज नहीं।',
  fin_receipt: 'रसीद',
  fin_void: 'रद्द',
  fin_record_expense: 'खर्च दर्ज करें',
  fin_f_amount: 'राशि (₹)',
  fin_ph_amount: 'जैसे 4200',
  fin_f_date: 'तारीख',
  fin_f_date_help: 'खाली = आज',
  fin_f_what: 'किसलिए?',
  fin_ph_what: 'जैसे लिफ्ट AMC — Q2 बिल',
  fin_f_receipt: 'रसीद फ़ोटो',
  fin_f_receipt_help: 'वैकल्पिक — अच्छा हिसाब',
  fin_recording: 'दर्ज हो रहा…',
  fin_record_expense_btn: 'खर्च दर्ज करें',

  // ---- marketing homepage (app/index.tsx) ----
  mkt_nav_gate: 'गेट सुरक्षा',
  mkt_nav_community: 'कम्युनिटी',
  mkt_nav_payments: 'पेमेंट',
  mkt_nav_pricing: 'कीमत',
  mkt_open_app: 'ऐप खोलें →',
  mkt_request_demo: 'डेमो का अनुरोध करें',
  mkt_see_how: 'यह कैसे काम करता है, देखें',
  mkt_hero_title: 'आपकी सोसाइटी का हर गेट, एक शांत ऐप में।',
  mkt_hero_sub: 'Bero शोरगुल वाले गेट ऐप्स की जगह लेता है। भारतीय हाउसिंग सोसाइटियों के लिए विज़िटर, नोटिस, पेमेंट और बुकिंग — बिना किसी विज्ञापन के, कभी नहीं।',
  mkt_f_gate_title: 'कहीं से भी, एक टैप में विज़िटर को मंज़ूरी दें।',
  mkt_f_gate_body: 'गार्ड गेट पर फ़ोटो और नंबर प्लेट लेते हैं; रहवासियों को काउंटडाउन के साथ पूरी स्क्रीन पर मंज़ूरी मिलती है। पहले से मंज़ूर मेहमान QR पास या 4-अंकों के PIN से अंदर आते हैं।',
  mkt_f_gate_p1: 'पूरी स्क्रीन पर मंज़ूरी',
  mkt_f_gate_p2: 'टिकट जैसे QR + PIN गेट पास',
  mkt_f_gate_p3: 'पंच इन/आउट के साथ स्टाफ़ हाज़िरी',
  mkt_f_gate_mock: 'आपके गेट पर',
  mkt_f_comm_title: 'ऐसे नोटिस जो लोग सच में पढ़ते हैं।',
  mkt_f_comm_body: 'ज़रूरी नोटिस के लिए पावती ज़रूरी होती है, पोल साफ़ नतीजों के साथ बंद होते हैं, और इवेंट फ्लैट के हिसाब से RSVP जमा करते हैं। चर्चाएँ शालीन रहती हैं क्योंकि हर कोई सत्यापित पड़ोसी है।',
  mkt_f_comm_p1: 'फ्लैट के हिसाब से पावती ट्रैकिंग',
  mkt_f_comm_p2: 'एक फ्लैट, एक वोट वाले पोल',
  mkt_f_comm_p3: 'सिर्फ़ सत्यापित रहवासी',
  mkt_f_pay_title: 'मेंटेनेंस समय पर, बिना बार-बार याद दिलाए।',
  mkt_f_pay_body: 'लाइन-आइटम ब्यौरे के साथ साफ़ इनवॉइस, दो टैप में UPI, तुरंत रसीद, और एक कमेटी डैशबोर्ड जो ठीक-ठीक दिखाता है किसने भुगतान किया — ताकि याद दिलाना नरम और कम-कभार हो।',
  mkt_f_pay_p1: 'UPI, कार्ड और ऑटो-पे',
  mkt_f_pay_p2: 'तुरंत PDF रसीद',
  mkt_f_pay_p3: 'कमेटी कलेक्शन डैशबोर्ड',
  mkt_f_pay_mock: 'जुलाई मेंटेनेंस',
  mkt_m_delivery_waiting: 'डिलीवरी · इंतज़ार में',
  mkt_m_guest_pass: 'गेस्ट पास {code}',
  mkt_m_housekeeping: 'हाउसकीपिंग · ड्यूटी पर',
  mkt_m_urgent_notice: 'ज़रूरी नोटिस',
  mkt_m_poll_voted: 'पोल · {n} ने वोट दिया',
  mkt_m_maint_sinking: 'मेंटेनेंस + सिंकिंग फंड',
  mkt_m_paid_via: '{date} को भुगतान · UPI',
  mkt_m_collections: 'कलेक्शन {pct}',
  mkt_m_of_flats: '{b} में से {a} फ्लैट',
  mkt_allow: 'अनुमति दें',
  mkt_valid: 'मान्य',
  mkt_rsvp: 'RSVP',
  mkt_pay: 'भुगतान करें',
  mkt_paid: 'भुगतान हुआ',
  mkt_live: 'लाइव',
  mkt_manifesto_title: 'आपकी सोसाइटी एक घर है, दर्शक नहीं।',
  mkt_manifesto_body: 'कोई विज्ञापन नहीं। कोई प्रायोजित बैनर नहीं। कोई "आपके पास के ऑफ़र" नहीं। आपका डेटा दलालों को बेचना नहीं। Bero का खर्च सोसाइटियाँ उठाती हैं, इसलिए रहवासी ग्राहक हैं — कभी उत्पाद नहीं।',
  mkt_stat_ads: 'दिखाए गए विज्ञापन',
  mkt_stat_brokers: 'डेटा दलाल',
  mkt_stat_funded: 'सोसाइटी-वित्तपोषित',
  mkt_pricing_kicker: 'सरल कीमत',
  mkt_pricing_per: 'प्रति फ्लैट / माह',
  mkt_pricing_body: 'सब कुछ शामिल — गेट, कम्युनिटी, पेमेंट, गार्ड कियोस्क। कोई टियर नहीं, कोई लॉक-इन नहीं।',
  mkt_pp1: 'असीमित रहवासी, गार्ड और एडमिन',
  mkt_pp2: 'गार्ड टैबलेट कियोस्क शामिल',
  mkt_pp3: 'हिन्दी, मराठी और अंग्रेज़ी',
  mkt_pp4: 'डेटा भारत में रहता है, कभी नहीं बिकता',
  mkt_demo_title: 'अपने ही गेट पर Bero देखें।',
  mkt_demo_body: 'आपकी कमेटी के साथ 30-मिनट का वॉकथ्रू। हम आपके विंग और फ्लैट के साथ एक सैंडबॉक्स सेट करते हैं।',
  mkt_link_privacy: 'प्राइवेसी',
  mkt_link_terms: 'शर्तें',
  mkt_link_contact: 'संपर्क',
  mkt_footer_copy: '© 2026 Bero Technologies Pvt Ltd, Mumbai',

  // ---- public gate-pass page (app/p/[code].tsx) ----
  pp_loading: 'पास लोड हो रहा है…',
  pp_invalid_title: 'यह पास लिंक अमान्य है',
  pp_invalid_body: 'यह समाप्त हो गया होगा या रद्द कर दिया गया होगा। अपने होस्ट से नया लिंक माँगें।',
  pp_or_tell_guard: 'या गार्ड को बताएँ',
  pp_visiting: 'मिलने आए',
  pp_valid_label: 'मान्य',
  pp_daily: 'रोज़ाना',
  pp_footer: 'इसे गेट पर दिखाएँ। गार्ड इसे अपने आप जाँच लेते हैं — किसी ऐप की ज़रूरत नहीं।',
  pp_status_active: 'सक्रिय',
  pp_status_upcoming: 'आगामी',
  pp_status_expired: 'समाप्त',
  pp_status_cancelled: 'रद्द',
  pp_multi_entry: 'कई बार प्रवेश',
  pp_single_entry: 'एक बार प्रवेश',
  pp_valid_until: '{time} तक मान्य',

  // ---- public party-invite page (app/i/[code].tsx) ----
  pi2_loading: 'न्योता लोड हो रहा है…',
  pi2_invalid_title: 'यह न्योते का लिंक अमान्य है',
  pi2_invalid_body: 'इसे रद्द कर दिया गया होगा। अपने होस्ट से नया लिंक माँगें।',
  pi2_society_invite: '{society} · न्योता',
  pi2_claim_prompt: 'अपना गेट पास पाने के लिए अपना नाम भरें{extra}।',
  pi2_n_left: ' — {n} बचे',
  pi2_name_ph: 'आपका नाम',
  pi2_get_pass: 'मेरा गेट पास पाएँ',
  pi2_getting: 'आपका पास मिल रहा है…',
  pi2_closed_full: 'इस न्योते के सभी गेस्ट पास ले लिए गए हैं। सीधे अपने होस्ट से पूछें।',
  pi2_closed_expired: 'यह न्योता समाप्त हो गया है। अपने होस्ट से नया लिंक माँगें।',
  pi2_closed_cancelled: 'होस्ट ने यह न्योता रद्द कर दिया।',
  pi2_err_generic: 'आपका पास नहीं मिल सका। फिर से कोशिश करें।',
  pi2_err_network: 'आपका पास नहीं मिल सका। अपना कनेक्शन जाँचें और फिर से कोशिश करें।',
  pi2_footer: 'आपके पास में एक QR और एक PIN है — गेट पर कोई एक दिखाएँ। किसी ऐप की ज़रूरत नहीं।',
  // desktop sidebar nav
  nav_profile: 'प्रोफ़ाइल',
  nav_vendors: 'वेंडर',
  nav_classifieds: 'क्लासिफ़ाइड',
  nav_lost_found: 'खोया-पाया',
  nav_birthdays: 'जश्न',
  nav_elections: 'चुनाव',
  nav_preapprove: 'विज़िटर पूर्व-स्वीकृति',
  nav_gate_pass: 'गेट पास',
  nav_visitor_history: 'विज़िटर इतिहास',
  nav_household_staff: 'घरेलू स्टाफ़',
  nav_parcels: 'पार्सल',
  nav_vehicles: 'गाड़ियाँ',
  nav_helpdesk: 'हेल्पडेस्क',
  nav_amenities: 'सुविधाएँ',
  nav_venue_booking: 'वेन्यू बुकिंग',
  nav_my_bookings: 'मेरी बुकिंग',
  nav_documents: 'दस्तावेज़',
  nav_residents: 'निवासी',
  nav_grp_management: 'प्रबंधन',
  nav_society_admin: 'सोसायटी एडमिन',
  nav_committee_desk: 'कमेटी डेस्क',
  nav_grp_living: 'रहन-सहन',
  nav_signed_in: 'साइन इन',
  // status pills
  pill_open: 'खुला',
  pill_progress: 'प्रगति में',
  pill_urgent: 'ज़रूरी',
  pill_resolved: 'हल हुआ',
  pill_approved: 'स्वीकृत',
  pill_pending: 'लंबित',
  pill_rejected: 'अस्वीकृत',
  pill_awaiting: 'प्रतीक्षारत',
  pill_at_gate: 'गेट पर',
  pill_left: 'रवाना',
  pill_inside: 'अंदर',
  pill_reported: 'रिपोर्ट किया',
  pill_picked_up: 'ले लिया',
  pill_primary: 'प्राथमिक',
  pill_lost: 'खोया',
  pill_found: 'मिला',
  pill_event: 'कार्यक्रम',
  pill_committee: 'कमेटी',
  pill_general: 'सामान्य',
  pill_cancelled: 'रद्द',
  pill_ended: 'समाप्त',
  pill_full: 'भरा',
  pill_active_now: 'अभी सक्रिय',
  pill_upcoming: 'आगामी',
  pill_expired: 'बीत गया',
  gp_pass_id: 'पास आईडी',
  home_maint_due: 'देय मेंटेनेंस',
  home_nothing_due: 'अभी कुछ भी देय नहीं है।',
  home_pay_maint: 'मेंटेनेंस भरें',
  home_community_empty: 'कम्युनिटी से कुछ नया नहीं।',
  svc_booked: 'बुक हो गया',
};
